<div class="hamburger-container">
  <mat-sidenav #sidenav mode="over" position="end" disableClose>
    <div #singlePropertyDetail class="propdetails_base container newContainer text-left">
      <div class="SideToolbar">
        <div class="btn-block">
          <button
            mat-flat-button
            *ngIf="multiplePropertyList.length > 0 && !showMultipleProperty"
            class="material-icons pull-left"
            (click)="showMultipleProperty = true"
          >
            <img src="../assets/images/left-arrow.svg" width="25" />
          </button>

          <div class="float-left">
            <nav class="navbar navbar-expand-sm">
              <ul class="navbar-nav">
                <li class="nav-item">
                  <a
                    class="nav-link active"
                    [ngClass]="{ active: currentDiv === 'overview' }"
                    (click)="scrollTo('overview')"
                    >Overview</a
                  >
                </li>
                <li
                  class="nav-item"
                  *ngIf="
                    [
                      'Auction',
                      'Pre-Foreclosure',
                      'Hudlisting',
                      'Bankowned',
                      'Pre-Foreclosure,Auction',
                      'Bankowned,Pre-Foreclosure'
                    ].includes(propertyInfo?.saletype) ||
                    [
                      'Auction',
                      'Pre-Foreclosure',
                      'Hudlisting',
                      'Bankowned',
                      'Pre-Foreclosure,Auction',
                      'Bankowned,Pre-Foreclosure'
                    ].includes(activePropertyDetails?.saletype) ||
                    (propertyInfo?.saletype &&
                      propertyInfo?.saletype.includes(',') &&
                      propertyInfo?.saletype.includes('Auction')) ||
                    (activePropertyDetails?.saletype &&
                      activePropertyDetails?.saletype.includes(',') &&
                      activePropertyDetails?.saletype.includes('Auction'))
                  "
                >
                  <a class="nav-link" [ngClass]="{ active: currentDiv === 'more' }" (click)="scrollTo('more')"
                    >Distress Info</a
                  >
                </li>
                <li class="nav-item">
                  <a class="nav-link" [ngClass]="{ active: currentDiv === 'property' }" (click)="scrollTo('property')"
                    >Property Details</a
                  >
                </li>
                <li class="nav-item">
                  <a
                    class="nav-link"
                    [ngClass]="{ active: currentDiv === 'value-tax-info' }"
                    (click)="scrollTo('value-tax-info')"
                    >Value & Tax Info</a
                  >
                </li>
                <li class="nav-item">
                  <a class="nav-link" [ngClass]="{ active: currentDiv === 'schools' }" (click)="scrollTo('schools')"
                    >Schools</a
                  >
                </li>
                <li class="nav-item">
                  <a class="nav-link" [ngClass]="{ active: currentDiv === 'trends' }" (click)="scrollTo('trends')"
                    >Trends</a
                  >
                </li>
              </ul>
            </nav>
          </div>
          <div class="prop_dtls_closeBtn pull-right" (click)="onClose()" aria-label="close property details">
            <img src="../assets/images/close.svg" tabindex="10" />
          </div>
          <div class="pr-4 m-actionbttn">
            <div
              class="btn-group mr-3 btn analyse_btn float-right"
              *ngIf="
                !hideDeal &&
                dealList &&
                dealList.length &&
                !showMultipleProperty &&
                isPropertyDataExists == true &&
                !isDealSheetOpened &&
                companyAppConfig?.dealAnalysis?.isEnabled &&
                !isMyHomeClicked
              "
              [ngClass]="{ movetoRight: !hideDeal && dealList && dealList.length }"
            >
              <div
                class="btn-group"
                *ngIf="!hideDeal && dealList && dealList.length && !isDealSheetOpened && !isMyHomeClicked"
                ngbDropdown
                role="group"
                aria-label="Button group with nested dropdown"
              >
                <button class="btn btn-primary dropdown-toggle-split" ngbDropdownToggle></button>
                <div class="dropdown-menu" ngbDropdownMenu>
                  <p class="headname mb-2 px-4"><b>Saved Analysis</b></p>
                  <div class="saved-analysis">
                    <ng-container *ngFor="let deal of dealList">
                      <div
                        class="saved-list"
                        color="primary"
                        (click)="openDealAnalysisSheetWithSavedDetails(deal)"
                        ngbDropdownItem
                      >
                        {{ deal.name }}
                      </div>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div
              class="btn-group mr-3 btn analyse_btn float-right"
              (click)="openDealAnalysisSheet(activePropertyDetails)"
              *ngIf="
                !dealList &&
                !showMultipleProperty &&
                isPropertyDataExists == true &&
                !isDealSheetOpened &&
                companyAppConfig?.dealAnalysis?.isEnabled &&
                !isMyHomeClicked
              "
              [ngClass]="{ movetoRight: !hideDeal && dealList && dealList.length }"
            >
              <button mat-button class="" id="analyse_prop" tabindex="10" name="Analyze property">
                {{ dealAnalysisButtonText }}
              </button>
            </div>
            <div
              class="btn-group mr-3 btn analyse_btn float-right"
              (click)="addOpportunity()"
              *ngIf="showAddOpportunity"
            >
              <div class="flex_center" *ngIf="isLoadingAddOpportunity">
                <mat-spinner [diameter]="30" class="mr-3"></mat-spinner>
              </div>
              <button
                mat-button
                class=""
                id="add_opportunity"
                tabindex="10"
                name="Add Opportunity"
                [disabled]="isLoadingAddOpportunity"
              >
                {{ addOpportunityButtonText }}
              </button>
            </div> -->

            <input
              type="text"
              size="0"
              style="
                width: 1px;
                height: 1px;
                border: none;
                background: none;
                box-shadow: none;
                cursor: default;
                outline: none;
              "
            />
            <button
              class="px-0 mat-stroked-button btn-group mr-1 mr-md-3 btn float-right sharebtn"
              mat-button
              color="primary"
              name="share property"
              aria-label="share property"
              *ngIf="!showMultipleProperty && isPropertyDataExists == true && !companyAppConfig?.valueReport?.isEnabled"
              (click)="propertyDetailsShare()"
              tabindex="10"
            >
              <mat-icon>share</mat-icon>
            </button>
            <button
              class="favbtn mr-1 mr-md-3 float-right"
              [ngClass]="activePropertyDetails.isFavorite ? 'favoritebtn' : ''"
              mat-flat-button
              data-toggle="tooltip"
              title="Add to Watchlist"
              (click)="followProperty(activePropertyDetails)"
              *ngIf="!companyAppConfig?.valueReport?.isEnabled"
            >
              <mat-icon [ngClass]="activePropertyDetails.isFavorite ? 'text-primary' : 'lightGreyCls'">
                favorite</mat-icon
              >
            </button>
            <!-- <div
              class="mr-1 mr-md-3 float-right"
              data-toggle="tooltip"
              title="Add to Watchlist"
              (click)="followProperty(activePropertyDetails)"
              *ngIf="!companyAppConfig?.valueReport?.isEnabled"
            >
              <button class="favbtn" [ngClass]="activePropertyDetails.isFavorite ? 'favoritebtn' : ''" mat-flat-button>
                <mat-icon [ngClass]="activePropertyDetails.isFavorite ? 'text-primary' : 'lightGreyCls'">
                  favorite</mat-icon
                >
              </button>
            </div> -->
          </div>
          <!-- All browsers on iPhones automatically focus on the first visible (not hidden) input field on the page 
              Added the below input field that is present but does not appear on the screen to force the focus to the top of the page.
            -->
        </div>
      </div>
      <div class="SideContent">
        <div class="wrapperLoad" *ngIf="propertySheetFacade.getMultiplePropertyDetailsSheetLoaderStatus() | async">
          <div class="wrapper-cell">
            <div class="text">
              <div class="text-line"></div>
              <div class="text-line"></div>
              <div class="text-line"></div>
            </div>
            <div class="image"></div>
          </div>
          <div class="wrapper-cell">
            <div class="text">
              <div class="text-line"></div>
              <div class="text-line"></div>
              <div class="text-line"></div>
            </div>
            <div class="image"></div>
          </div>
          <div class="wrapper-cell">
            <div class="text">
              <div class="text-line"></div>
              <div class="text-line"></div>
              <div class="text-line"></div>
            </div>
            <div class="image"></div>
          </div>
          <div class="wrapper-cell">
            <div class="text">
              <div class="text-line"></div>
              <div class="text-line"></div>
              <div class="text-line"></div>
            </div>
            <div class="image"></div>
          </div>
          <div class="wrapper-cell">
            <div class="text">
              <div class="text-line"></div>
              <div class="text-line"></div>
              <div class="text-line"></div>
            </div>
            <div class="image"></div>
          </div>
          <div class="wrapper-cell">
            <div class="text">
              <div class="text-line"></div>
              <div class="text-line"></div>
              <div class="text-line"></div>
            </div>
            <div class="image"></div>
          </div>
          <div class="wrapper-cell">
            <div class="text">
              <div class="text-line"></div>
              <div class="text-line"></div>
              <div class="text-line"></div>
            </div>
            <div class="image"></div>
          </div>
          <div class="wrapper-cell">
            <div class="text">
              <div class="text-line"></div>
              <div class="text-line"></div>
              <div class="text-line"></div>
            </div>
            <div class="image"></div>
          </div>
          <div class="wrapper-cell">
            <div class="text">
              <div class="text-line"></div>
              <div class="text-line"></div>
              <div class="text-line"></div>
            </div>
            <div class="image"></div>
          </div>
          <div class="wrapper-cell">
            <div class="text">
              <div class="text-line"></div>
              <div class="text-line"></div>
              <div class="text-line"></div>
            </div>
            <div class="image"></div>
          </div>
        </div>
        <div
          class="fixedBottom absoluteBottom fullAbsoluteload flex_center alert text-white"
          *ngIf="propertySheetFacade.getPropertyDetailsSheetLoaderStatus() | async"
        >
          <div class="flex_center">
            <mat-spinner [diameter]="30" class="mr-3"></mat-spinner> Please wait while we load details
          </div>
        </div>

        <!-- Single Property Details -->
        <div
          class="propdetails_wrap singleDetails"
          (wheel)="onMouseWheel($event)"
          *ngIf="!showMultipleProperty && isPropertyDataExists == true"
        >
          <div class="transition is-stickyActive scroller1">
            <hr />

            <div class="clearfix"></div>
            <!-- Bird's Eye/Street View -->

            <div class="section_base scroller1">
              <div class="col-sm-12">
                <div class="row"></div>
              </div>
            </div>
            <!-- Owner Information -->
            <div class="row" *ngIf="activePropertyDetails">
              <div class="scroller1 col-sm-12 col-md-7 col-lg-8" id="info_section">
                <div class="clearfix"></div>

                <div class="scroller1" *ngIf="activePropertyDetails">
                  <div class="clearfix"></div>
                  <div class="row BirdStreetView" *ngIf="!propertyInfo || !listingImages.length">
                    <mat-radio-group
                      aria-label="Select a view"
                      (change)="onViewChange($event)"
                      #radioGroup="matRadioGroup"
                      [(ngModel)]="selectedMapView"
                    >
                      <mat-radio-button value="streetView" checked>Street View </mat-radio-button>
                      <mat-radio-button class="pl-2" value="birdsEyeView">Bird's Eye View</mat-radio-button>
                    </mat-radio-group>
                  </div>
                  <div class="col-lg-12 px-0 listing_carousel" *ngIf="listingImages.length">
                    <div class="info_carousal">
                      <div id="demo" class="carousel slide">
                        <app-image-gallery> </app-image-gallery>
                      </div>
                    </div>
                  </div>
                  <ng-container *ngIf="!propertyInfo || !listingImages.length">
                    <div class="col-lg-12 px-0" [hidden]="isStreetView">
                      <app-birds-eye-view
                        [defaultPlace]="setBirdsEyeViewEvent"
                        (birdsEyeViewEvent)="setBirdsEyeView($event)"
                      >
                      </app-birds-eye-view>
                    </div>
                    <div class="col-lg-12 px-0" [hidden]="!isStreetView">
                      <app-street-view
                        [defaultPlace]="setStreetViewEvent"
                        (streetViewAvailable)="onStreetViewAvailable($event)"
                        (streetViewEvent)="setStreetView($event)"
                      >
                      </app-street-view>
                    </div>
                  </ng-container>
                  <div
                    class="sectioninfo col-lg-12"
                    *ngIf="propertyInfo && activePropertyDetails"
                    id="overview"
                    [ngStyle]="onScrollEvent"
                  >
                    <div class="row mt-4">
                      <div class="col-lg-8 col-md-8 col-8 pl-0" style="display: flex" *ngIf="!isAvoidListing">
                        <h2
                          class="mb-1"
                          *ngIf="
                            propertyInfo.filterStyleClass !== 'sold' &&
                            activePropertyDetails.filterStyleClass !== 'sold' &&
                            propertyInfo.filterStyleClass !== 'nonFiltered' &&
                            activePropertyDetails.filterStyleClass !== 'nonFiltered'
                          "
                          [innerHTML]="
                            listingData.ListPrice ||
                              propertyInfo.Lst_ListPrice ||
                              activePropertyDetails.Lst_ListPrice ||
                              propertyInfo.CurrentAVMValue
                              | CurrencyFormatter
                              | IsValueExist
                          "
                        ></h2>
                        <h2
                          class="mb-1"
                          *ngIf="
                            propertyInfo?.filterStyleClass == 'sold' ||
                            activePropertyDetails?.filterStyleClass == 'sold' ||
                            propertyInfo.filterStyleClass == 'nonFiltered' ||
                            activePropertyDetails.filterStyleClass == 'nonFiltered'
                          "
                          [innerHTML]="
                            companyName === 'valuetest'
                              ? '--'
                              : (propertyInfo.CurrentAVMValue || activePropertyDetails.CurrentAVMValue
                                | CurrencyFormatter
                                | IsValueExist)
                          "
                        ></h2>
                        <sub
                          *ngIf="
                            (propertyInfo.filterStyleClass == 'nonFiltered' ||
                              activePropertyDetails.filterStyleClass == 'nonFiltered') &&
                            (propertyInfo.CurrentAVMValue || activePropertyDetails.CurrentAVMValue) &&
                            companyName != 'valuetest'
                          "
                          class="lh-3"
                          ><span><b>Propmix Estimated Value</b></span></sub
                        >
                        <div
                          class="difValue"
                          *ngIf="propertyInfo.Lst_OriginalListPrice - propertyInfo.Lst_ListPrice > 0"
                        >
                          <img
                            [src]="
                              propertyInfo.Lst_OriginalListPrice - propertyInfo.Lst_ListPrice > 0
                                ? 'assets/images/arrow-up.svg'
                                : 'assets/images/down-arrow.svg'
                            "
                            height="22px"
                          />
                          {{
                            propertyInfo.Lst_OriginalListPrice - propertyInfo.Lst_ListPrice
                              | CurrencyFormatter
                              | IsValueExist
                          }}
                        </div>
                      </div>

                      <div class="col-lg-8 col-md-8 col-8 pl-0" style="display: flex" *ngIf="isAvoidListing">
                        <h2
                          class="mb-1"
                          [innerHTML]="
                            companyName === 'valuetest'
                              ? '--'
                              : (propertyInfo.CurrentAVMValue || activePropertyDetails.CurrentAVMValue
                                | CurrencyFormatter)
                          "
                        ></h2>
                        <sub
                          *ngIf="
                            (!propertyInfo.Lst_ListPrice &&
                              !activePropertyDetails.Lst_ListPrice &&
                              !listingData.ListPrice &&
                              propertyInfo.CurrentAVMValue) ||
                            (activePropertyDetails.CurrentAVMValue && companyName != 'valuetest')
                          "
                          class="lh-3"
                          ><span><b>Propmix Estimated Value</b></span></sub
                        >
                        <div
                          class="difValue"
                          *ngIf="propertyInfo.Lst_OriginalListPrice - propertyInfo.Lst_ListPrice > 0"
                        >
                          <img
                            [src]="
                              propertyInfo.Lst_OriginalListPrice - propertyInfo.Lst_ListPrice > 0
                                ? 'assets/images/arrow-up.svg'
                                : 'assets/images/down-arrow.svg'
                            "
                            height="22px"
                          />
                          {{
                            propertyInfo.Lst_OriginalListPrice - propertyInfo.Lst_ListPrice
                              | CurrencyFormatter
                              | IsValueExist
                          }}
                        </div>
                      </div>

                      <div class="col-lg-4 col-md-4 col-4 pr-0" *ngIf="!isAvoidListing">
                        <span
                          class="property-badge sale-type mt-2"
                          [ngClass]="propertyInfo.filterStyleClass || activePropertyDetails.filterStyleClass"
                        >
                          <span
                            *ngIf="
                              propertyInfo.filterStyleClass == 'listing' ||
                              activePropertyDetails.filterStyleClass == 'listing'
                            "
                          >
                            {{
                              listingData.MlsBoard != 'MREIS'
                                ? propertyInfo.Lst_StandardStatus || activePropertyDetails.Lst_StandardStatus
                                : RawMlsStatus
                            }}
                          </span>
                          <div *ngIf="RawMlsStatus != 'Deleted'">
                            <span
                              *ngIf="
                                propertyInfo.filterStyleClass == 'sold' ||
                                activePropertyDetails.filterStyleClass == 'sold'
                              "
                            >
                              {{
                                listingData.MlsBoard != 'MREIS'
                                  ? propertyInfo.Lst_StandardStatus || activePropertyDetails.Lst_StandardStatus
                                  : RawMlsStatus
                              }}
                            </span>
                          </div>
                          <span
                            *ngIf="
                              (propertyInfo.filterStyleClass == 'distressed' ||
                                activePropertyDetails.filterStyleClass == 'distressed') &&
                              !propertyInfo?.addUpdatedBadge &&
                              !activePropertyDetails?.addUpdatedBadge
                            "
                          >
                            <span class="listings">
                              {{
                                propertyInfo?.Lst_StandardStatus || activePropertyDetails?.Lst_StandardStatus
                                  | titlecase
                              }}
                            </span>
                            <span class="distressed">
                              {{
                                propertyInfo?.Lst_speciallistingconditions ||
                                  activePropertyDetails?.Lst_speciallistingconditions ||
                                  propertyInfo?.Fcl_Status ||
                                  activePropertyDetails?.Fcl_Status | titlecase
                              }}</span
                            >
                          </span>
                          <span *ngIf="activePropertyDetails.addUpdatedBadge || propertyInfo?.addUpdatedBadge">
                            <span class="listings">{{
                              propertyInfo?.Lst_StandardStatus || activePropertyDetails?.Lst_StandardStatus | titlecase
                            }}</span>
                            <span
                              [ngClass]="activePropertyDetails?.filterStyleClass || propertyInfo?.filterStyleClass"
                              >{{
                                propertyInfo?.addUpdatedBadge || activePropertyDetails?.addUpdatedBadge | titlecase
                              }}</span
                            >
                          </span>

                          <span
                            *ngIf="
                              (propertyInfo?.filterStyleClass == 'hud' ||
                                activePropertyDetails.filterStyleClass == 'hud') &&
                              !propertyInfo?.addUpdatedBadge &&
                              !activePropertyDetails.addUpdatedBadge
                            "
                          >
                            <span class="listings">
                              {{
                                propertyInfo?.Lst_StandardStatus || activePropertyDetails.Lst_StandardStatus | titlecase
                              }}</span
                            >
                            <span class="hud">
                              {{
                                propertyInfo?.Lst_speciallistingconditions ||
                                  activePropertyDetails.Lst_speciallistingconditions | titlecase
                              }}
                            </span>
                          </span>

                          <span *ngIf="propertyInfo.filterStyleClass == 'nonFiltered'">
                            <span class="offMarket"> Off Market </span>
                          </span>

                          <span
                            *ngIf="
                              (
                                listingData?.RawMlsStatus ||
                                propertyInfo?.Lst_RawMlsStatus ||
                                activePropertyDetails?.Lst_RawMlsStatus
                              )
                                ?.toLowerCase()
                                .includes('coming soon')
                            "
                          >
                            <span class="upcoming"> Coming Soon </span>
                          </span>
                        </span>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-lg-8 col-md-8 col-12 pl-0">
                        <div class="mb-0 prop-ads">
                          {{
                            listingData &&
                            listingData.InternetAddressDisplayYN == 'N' &&
                            listingData.MlsBoard === 'MREIS'
                              ? ''
                              : activePropertyDetails?.propertyAddress || activePropertyDetails?.StreetAddress
                          }}, {{ activePropertyDetails?.City || listingData?.City || '--' }},
                          {{ activePropertyDetails?.StateOrProvince || listingData?.StateOrProvince || '--' }}
                          {{ activePropertyDetails?.PostalCode || listingData?.PostalCode }}
                        </div>
                      </div>
                      <div class="col-lg-4 col-md-4 col-12 pr-0 pl-0" *ngIf="isAvoidListing === false">
                        <div
                          class="Listed-on"
                          *ngIf="
                            [null, 'unlisted'].includes(
                              listingData?.StandardStatus?.toLowerCase() ||
                                propertyInfo?.Lst_StandardStatus?.toLowerCase() ||
                                activePropertyDetails?.Lst_StandardStatus?.toLowerCase()
                            )
                          "
                        >
                          {{
                            listingData?.RawMlsStatus ||
                            propertyInfo?.Lst_RawMlsStatus ||
                            activePropertyDetails?.Lst_RawMlsStatus
                              ? toTitleCase(
                                  listingData?.RawMlsStatus ||
                                    propertyInfo?.Lst_RawMlsStatus ||
                                    activePropertyDetails?.Lst_RawMlsStatus
                                ) + ' On:'
                              : ''
                          }}
                          <span
                            *ngIf="listingData && listingData.onMarketDate"
                            [innerHTML]="listingData.OnMarketDate | date: 'mediumDate' | IsValueExist"
                          ></span>
                        </div>
                        <div
                          class="Listed-on"
                          *ngIf="
                            ['active', 'pending', 'active under contract'].includes(
                              listingData?.StandardStatus?.toLowerCase() ||
                                propertyInfo?.Lst_StandardStatus?.toLowerCase() ||
                                activePropertyDetails?.Lst_StandardStatus?.toLowerCase()
                            )
                          "
                        >
                          Listed On:
                          <span
                            [innerHTML]="
                              listingData.ListingContractDate ||
                                propertyInfo.Lst_ListingContractDate ||
                                activePropertyDetails.Lst_ListingContractDate
                                | date: 'mediumDate'
                                | IsValueExist
                            "
                          ></span>
                        </div>
                        <div
                          class="Listed-on"
                          *ngIf="
                            (['Auction', 'Pre-Foreclosure,Auction'].includes(propertyInfo?.saletype) ||
                              ['Auction', 'Pre-Foreclosure,Auction'].includes(activePropertyDetails?.saletype) ||
                              (propertyInfo?.saletype &&
                                propertyInfo?.saletype.includes(',') &&
                                propertyInfo?.saletype.includes('Auction')) ||
                              (activePropertyDetails?.saletype &&
                                activePropertyDetails?.saletype.includes(',') &&
                                activePropertyDetails?.saletype.includes('Auction'))) &&
                            ((propertyInfo.Fcl_lastauctionDate && propertyInfo.Fcl_lastauctionDate > today) ||
                              (activePropertyDetails.Fcl_lastauctionDate &&
                                activePropertyDetails.Fcl_lastauctionDate > today))
                          "
                        >
                          Auction Date:
                          <span
                            [innerHTML]="
                              propertyInfo.Fcl_lastauctionDate || activePropertyDetails.Fcl_lastauctionDate
                                | date: 'mediumDate'
                                | IsValueExist
                            "
                          ></span>
                        </div>
                        <!-- </div> -->
                      </div>
                    </div>
                    <div class="row mt-2">
                      <div class="col-lg-12 pl-0">
                        <ul class="prop_highlight pl-0 mb-0 mt-3">
                          <li [matTooltip]="'Bed'">
                            <img src="../../assets/images/bed.svg" width="24" />
                            <p class="inline-block ipad_amn_break ml-1">
                              {{
                                propertyInfo.PropertyType === 'Land' || activePropertyDetails.PropertyType === 'Land'
                                  ? '--'
                                  : ((listingData.BedroomsTotal | number: '1.0-0') ||
                                      propertyInfo.BedroomsTotal ||
                                      activePropertyDetails.BedroomsTotal | IsValueExist)
                              }}
                            </p>
                          </li>
                          <li [matTooltip]="'Bath'">
                            <img src="../../assets/images/bath.svg" width="24" />
                            <p class="inline-block ipad_amn_break ml-1">
                              {{
                                propertyInfo.PropertyType === 'Land' || activePropertyDetails.PropertyType === 'Land'
                                  ? '--'
                                  : ((listingData.BathroomsTotalInteger | number: '1.0-0') ||
                                      propertyInfo?.BathroomsTotalInteger ||
                                      activePropertyDetails.BathroomsTotalInteger | IsValueExist)
                              }}
                            </p>
                          </li>
                          <li [matTooltip]="'Living Area'">
                            <img src="../../assets/images/living_area.svg" width="24" />
                            <p class="inline-block ipad_amn_break ml-1">
                              {{
                                propertyInfo.PropertyType === 'Land' || activePropertyDetails.PropertyType === 'Land'
                                  ? '--'
                                  : ((listingData.LivingArea | number: '1.0-0') ||
                                      propertyInfo?.LivingArea ||
                                      activePropertyDetails.LivingArea | IsValueExist)
                              }}
                              <small>sq.ft</small>
                            </p>
                          </li>
                          <li [matTooltip]="'Lot Size Square Feet'">
                            <img src="../../assets/images/land_area.svg" width="24" />
                            <p class="inline-block ipad_amn_break ml-1">
                              {{
                                (listingData.LotSizeSquareFeet | number: '1.0-0') ||
                                  propertyInfo?.LotSizeSquareFeet ||
                                  activePropertyDetails.LotSizeSquareFeet | IsValueExist
                              }}
                              <small>sq.ft</small>
                            </p>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div class="row mt-4">
                      <div class="col-lg-4 col-sm-6 col-6 pl-0 mb-3">
                        <h5 class="mb-1" class="propertyDetailsSectionValue">
                          {{ propertyInfo.PropertySubType || activePropertyDetails.PropertySubType }}
                        </h5>
                        <span>Property Type</span>
                      </div>
                      <div class="col-lg-4 col-sm-6 col-6 pl-0 mb-3" *ngIf="!isAvoidListing">
                        <h5 class="mb-1" class="propertyDetailsSectionValue">{{ calculateDays(listingData) }}</h5>
                        <div class="days-market-label">
                          <span>Days on Market</span>
                        </div>
                        <div *ngIf="listingData.MlsBoard === 'MREIS'" class="source"><b>Source:</b> PropMix.io LLC</div>
                      </div>
                      <div class="col-lg-4 col-sm-6 col-6 pl-0 mb-3">
                        <h5 class="mb-1" class="propertyDetailsSectionValue">
                          ${{ listingData.PriceperSquareFeet || '--' }}
                        </h5>
                        <div class="days-market-label">
                          <span>Price per sq.ft</span>
                        </div>
                        <div *ngIf="listingData.MlsBoard === 'MREIS'" class="source"><b>Source:</b> PropMix.io LLC</div>
                      </div>
                      <div
                        class="col-lg-4 col-sm-6 col-6 pl-0 mb-3"
                        *ngIf="
                          (propertyInfo?.PropertySubType || activePropertyDetails?.PropertySubType) != 'Other Land'
                        "
                      >
                        <h5 class="mb-1">
                          {{ listingData.YearBuilt || activePropertyDetails.YearBuilt | IsValueExist }}
                        </h5>
                        <span>Year Built</span>
                      </div>
                      <div
                        class="col-lg-4 col-sm-6 col-6 pl-0 mb-3"
                        *ngIf="
                          !isAvoidListing &&
                          (propertyInfo?.PropertySubType || activePropertyDetails?.PropertySubType) != 'Other Land'
                        "
                      >
                        <h5 class="mb-1">
                          <b *ngIf="associationFee" class="propertyDetailsSectionValue"
                            >{{ associationFee | CurrencyFormatter | IsValueExist }}/month</b
                          >
                          <b *ngIf="!associationFee">--</b>
                        </h5>
                        <span>Association Fee</span>
                      </div>
                      <div
                        class="col-lg-4 col-sm-6 col-6 pl-0 mb-3"
                        *ngIf="
                          (propertyInfo?.PropertySubType || activePropertyDetails?.PropertySubType) != 'Other Land'
                        "
                      >
                        <h5 class="mb-1" class="propertyDetailsSectionValue">
                          {{ listingData.ParkingSpaces || activePropertyDetails.ParkingSpaces | IsValueExist }}
                        </h5>
                        <span>Parking Total</span>
                      </div>
                      <div
                        class="col-lg-4 col-sm-6 col-6 pl-0 mb-3"
                        *ngIf="
                          (propertyInfo?.PropertySubType || activePropertyDetails?.PropertySubType) != 'Other Land'
                        "
                      >
                        <h5 class="mb-1" class="propertyDetailsSectionValue">
                          {{
                            listingData.GarageYN
                              ? listingData.GarageYN == 'Y'
                                ? 'Yes'
                                : 'No'
                              : activePropertyDetails.GarageArea
                              ? 'Yes'
                              : 'No'
                          }}
                        </h5>
                        <span>Garage Spaces</span>
                      </div>
                      <div
                        class="col-lg-4 col-sm-6 col-6 pl-0 mb-3"
                        *ngIf="
                          (propertyInfo?.PropertySubType || activePropertyDetails?.PropertySubType) != 'Other Land'
                        "
                      >
                        <h5 class="mb-1" class="propertyDetailsSectionValue">
                          {{
                            listingData.ArchitecturalStyle || activePropertyDetails.ArchitecturalStyle | IsValueExist
                          }}
                        </h5>
                        <span>Architectural Style</span>
                      </div>
                      <div
                        class="col-lg-4 col-sm-6 col-6 pl-0 mb-3"
                        *ngIf="
                          (propertyInfo?.PropertySubType || activePropertyDetails?.PropertySubType) != 'Other Land'
                        "
                      >
                        <h5 class="mb-1" class="propertyDetailsSectionValue">
                          {{ listingData.PoolType || activePropertyDetails.PoolType | IsValueExist }}
                        </h5>
                        <span>Pool</span>
                      </div>
                      <div
                        class="col-lg-4 col-sm-6 col-6 pl-0 mb-3"
                        *ngIf="
                          (propertyInfo?.PropertySubType || activePropertyDetails?.PropertySubType) != 'Other Land'
                        "
                      >
                        <h5 class="mb-1" class="propertyDetailsSectionValue">
                          {{
                            (listingData.DerivedStories | number: '1.0-0') ||
                              propertyInfo?.StoriesTotal ||
                              activePropertyDetails.StoriesTotal ||
                              '--'
                          }}
                        </h5>
                        <span>Stories</span>
                      </div>
                    </div>
                    <div class="row mt-3 list-data" *ngIf="!isAvoidListing">
                      <div class="mb-2">
                        <span>
                          {{ showMore ? listingData.PublicRemarks : (listingData.PublicRemarks | slice: 0:150) }}
                          <a class="linkCursor" *ngIf="!showMore" (click)="onShow()">Show More</a>
                          <a class="linkCursor" *ngIf="showMore" (click)="onShow()">Show Less</a>
                        </span>
                      </div>

                      <div class="mb-2 mt-2">
                        <b>Last Checked:</b> In the last 15 minutes | <b>Last Updated:</b>
                        {{ listingData.ModificationTimestamp | date: 'yyyy-MM-dd' }} | <b>Source:</b>
                        {{ listingData.OriginatingSystemName }}
                        <img src="{{ mlsLogo }}" height="40" class="ml-2" />
                        <br /><span>MLS#: {{ listingData.MlsListingNumber | IsValueExist }}</span>
                      </div>

                      <div
                        class="mb-2 copyright"
                        *ngIf="companyAppConfig?.propertyDetails?.hideListingAgentContactInfo"
                      >
                        Courtesy of: {{ listingData.ListOfficeName | IsValueExist }}
                      </div>

                      <div class="mb-2 copyright">Disclaimer: {{ mlsDisclaimer }}</div>
                      <div class="disclaimer-housing-logo" *ngIf="listingData.MlsBoard === 'MREIS'">
                        <img src="/assets/images/equal-housing-opportunity.png" alt="Equal Housing Opportunity" />
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-12 m-block px-0 pt-3">
                        <div class="propdetails_rightsec">
                          <mat-accordion multi="true">
                            <mat-expansion-panel
                              class="contact-agent mb-4"
                              [expanded]="true"
                              *ngIf="
                                ['active', 'pending', 'active under contract'].includes(
                                  listingData?.StandardStatus?.toLowerCase() ||
                                    propertyInfo?.Lst_StandardStatus?.toLowerCase() ||
                                    activePropertyDetails?.Lst_StandardStatus?.toLowerCase()
                                ) && canViewAgentContactInfo
                              "
                            >
                              <mat-expansion-panel-header>
                                <mat-panel-title>
                                  <h4 class="mb-0">Contact Agent</h4>
                                </mat-panel-title>
                              </mat-expansion-panel-header>
                              <app-agent-contact> </app-agent-contact>
                            </mat-expansion-panel>
                            <div *ngIf="enableCmaButton">
                              <button class="button-single" mat-flat-button color="primary" (click)="createCma()">
                                Create CMA
                              </button>
                            </div>
                            <div class="listed-by-card shadow-1">
                              <h4 class="section-title">
                                {{
                                  propertyInfo?.Lst_StandardStatus === 'Sold' ||
                                  propertyInfo?.Lst_StandardStatus === 'Cancel / withdrawn'
                                    ? 'Sold By'
                                    : 'Listed By'
                                }}
                              </h4>
                              <div class="listing-grid">
                                <div class="info-row">
                                  <div class="icon-box">
                                    <span class="material-icons">person</span>
                                  </div>
                                  <div class="info-content">
                                    <div class="info-value">
                                      {{ listingData.ListAgentFullName || '--' }}
                                    </div>
                                  </div>
                                </div>

                                <div class="info-row">
                                  <div class="icon-box">
                                    <span class="material-icons">business</span>
                                  </div>
                                  <div class="info-content">
                                    <div class="info-value">
                                      {{ listingData.ListOfficeName || '--' }}
                                    </div>
                                  </div>
                                </div>

                                <div class="info-row">
                                  <div class="icon-box">
                                    <span class="material-icons">phone</span>
                                  </div>
                                  <div class="info-content">
                                    <div class="info-value">
                                      <div class="info-content">
                                        <div class="info-value">
                                          {{
                                            listingData.InternetAttributionContact ||
                                              listingData.ListAgentPreferredPhone ||
                                              listingData.ListAgentCellPhone ||
                                              listingData.Lst_ListAgentPhone ||
                                              listingData.ListAgentOfficePhone ||
                                              listingData.ListOfficePhone ||
                                              '--'
                                          }}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div class="info-row">
                                  <div class="icon-box">
                                    <span class="material-icons">email</span>
                                  </div>
                                  <div class="info-content">
                                    <div class="info-value">
                                      {{
                                        (listingData.MlsBoard === 'MREIS'
                                          ? listingData.ListOfficeEmail
                                          : listingData.ListAgentEmail) || '--'
                                      }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div class="property-navigation-card" (click)="scrollTo('propertyAnalysis')">
                              <div class="property-icon">
                                <img src="../../../../assets/images/analyse.svg" />
                              </div>
                              <div class="property-content">
                                <div class="property-title">Investment Analysis</div>
                                <div class="property-description">See investment and development potential</div>
                              </div>
                              <div class="property-arrow">›</div>
                            </div>

                            <mat-expansion-panel
                              [expanded]="true"
                              *ngIf="
                                ['active', 'pending', 'active under contract'].includes(
                                  listingData?.StandardStatus?.toLowerCase() ||
                                    propertyInfo?.Lst_StandardStatus?.toLowerCase() ||
                                    activePropertyDetails?.Lst_StandardStatus?.toLowerCase()
                                ) && canViewAgentContactInfo
                              "
                            >
                              <mat-expansion-panel-header>
                                <mat-panel-title>
                                  <h4 class="mb-0">Payment Calculator</h4>
                                </mat-panel-title>
                              </mat-expansion-panel-header>
                              <p class="bold ml-3 mb-0">Calculator and Data provided by PropMix.io LLC</p>
                              <app-payment-calculator class="pt-4 pt-md-3 pt-lg-4"> </app-payment-calculator>
                            </mat-expansion-panel>
                          </mat-accordion>
                        </div>
                        <br />
                      </div>
                    </div>

                    <!-- buttons wrapper -->
                    <div
                      class="row"
                      id="propertyAnalysis"
                      #propertyAnalysis
                      [ngStyle]="onScrollEvent"
                      *ngIf="
                        companyAppConfig?.opportunityScanner?.isEnabled || companyAppConfig?.dealAnalysis?.isEnabled
                      "
                    >
                      <div class="propertyAnalizeButtonWrapper">
                        <div class="analyze-header">
                          <div class="header-icon">
                            <img src="../../../../assets/images/trendsInfo.svg" />
                          </div>
                          <div>
                            <h3>What can you do with this property?</h3>
                            <p>Explore both investment and development opportunities.</p>
                          </div>
                        </div>
                        <div class="analyze-options">
                          <div class="analyze-card rental-card" *ngIf="companyAppConfig?.dealAnalysis?.isEnabled">
                            <div class="card-top">
                              <div class="card-icon rental-icon">
                                <img src="../../../../assets/images/homee.svg" />
                              </div>
                              <div class="card-title">
                                <h4>Buy &amp; Rent</h4>
                                <p>
                                  See rental income, cash flow equity, and<br />
                                  ROI for this property as it exists today.
                                </p>
                              </div>
                            </div>
                            <div class="tags">
                              <span>Rental Income</span>
                              <span>Cash Flow</span>
                              <span>Equity</span>
                              <span>ROI</span>
                            </div>
                            <div class="action-btn rental-btn" (click)="openDealAnalysisSheet(activePropertyDetails)">
                              <button mat-button class="" id="analyse_prop" tabindex="10" name="Analyze property">
                                Estimate Rental ROI
                              </button>
                            </div>
                            <!-- <div
                              class="action-btn rental-btn" (click)="openDealAnalysisSheet(activePropertyDetails)"
                              *ngIf="
                                !dealList &&
                                !showMultipleProperty &&
                                isPropertyDataExists == true &&
                                !isDealSheetOpened &&
                                companyAppConfig?.dealAnalysis?.isEnabled &&
                                !isMyHomeClicked
                              ">
                              <button mat-button class="" id="analyse_prop" tabindex="10" name="Analyze property">
                                {{ dealAnalysisButtonText }}
                              </button>
                            </div> -->
                          </div>

                          <!-- Build & Invest -->
                          <div class="analyze-card build-card" *ngIf="companyAppConfig?.opportunityScanner?.isEnabled">
                            <div class="card-top">
                              <div class="card-icon build-icon">
                                <img src="../../../../assets/images/crane.svg" />
                              </div>
                              <div class="card-title">
                                <div class="title-row">
                                  <h4>Buy &amp; Redevelop</h4>
                                  <span class="new-badge">NEW</span>
                                </div>
                                <p>
                                  See what you could build on this property,<br />
                                  estimated costs, potential value and ROI.
                                </p>
                              </div>
                            </div>
                            <div class="tags">
                              <span>Zoning &amp; FAR</span>
                              <span>Build Cost</span>
                              <span>Potential Value</span>
                              <span>ROI</span>
                            </div>
                            <div class="action-btn build-btn" (click)="addOpportunity()">
                              <div class="flex_center" *ngIf="isLoadingAddOpportunity">
                                <mat-spinner [diameter]="30" class="mr-3"></mat-spinner>
                              </div>
                              <button
                                mat-button
                                id="add_opportunity"
                                tabindex="10"
                                name="Add Opportunity"
                                [disabled]="isLoadingAddOpportunity"
                              >
                                Estimate Build ROI
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-lg-12 mt-4" #mapElement style="width: 100%; height: 300px"></div>
                    </div>
                  </div>

                  <div class="section_base ownerNameWrap" *ngIf="appState.authTokenValue?.idToken">
                    <div class="row ml-0 mr-0">
                      <div class="col-lg-12">
                        <div class="leftSide">
                          <label>Owner Name :</label>
                          <h6 class="truncate">
                            {{ activePropertyDetails.Owner1FullName || propertyInfo?.Owner1FullName | IsValueExist }}
                          </h6>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="clearfix"></div>
                  <div class="section_base">
                    <div
                      *ngIf="
                        ['Auction', 'Hudlisting', 'Pre-Foreclosure', 'Bankowned', 'Pre-Foreclosure,Auction'].includes(
                          propertyInfo?.saletype
                        ) ||
                        ['Auction', 'Hudlisting', 'Pre-Foreclosure', 'Bankowned', 'Pre-Foreclosure,Auction'].includes(
                          activePropertyDetails?.saletype
                        ) ||
                        (propertyInfo?.saletype &&
                          propertyInfo?.saletype.includes(',') &&
                          propertyInfo?.saletype.includes('Auction')) ||
                        (activePropertyDetails?.saletype &&
                          activePropertyDetails?.saletype.includes(',') &&
                          activePropertyDetails?.saletype.includes('Auction'))
                      "
                    >
                      <ng-container *ngTemplateOutlet="distressedInfoContent"></ng-container>
                    </div>

                    <!-- Property Information -->

                    <div class="sectioninfo mt-4" id="property" #property [ngStyle]="onScrollEvent">
                      <h4 class="headTitle">
                        <img src="../../../assets/images/propertyInfo.svg" class="mr-2" width="18" /> Property
                        Information
                      </h4>

                      <!-- Location Information -->

                      <div class="propertCharacter">
                        <div class="row">
                          <div class="col-lg-12">
                            <h6 class="my-3 headWrap">Location Information</h6>
                            <ul class="pl-0 w-100 prop_char">
                              <li>
                                <div>Parcel Number:</div>
                                <div class="propertyDetailsSectionValue">
                                  {{ listingData.ParcelNumber || activePropertyDetails.ParcelNumber | IsValueExist }}
                                </div>
                              </li>
                              <li>
                                <div>County:</div>
                                <div class="propertyDetailsSectionValue">{{ activeCountyValue | IsValueExist }}</div>
                              </li>
                              <li>
                                <div>Association Name:</div>
                                <div class="propertyDetailsSectionValue">
                                  {{ listingData.AssociationName | IsValueExist }}
                                </div>
                              </li>
                              <li>
                                <div>Subdivision Name:</div>
                                <div class="propertyDetailsSectionValue">
                                  {{
                                    listingData.SubdivisionName || activePropertyDetails.LegalSubdivisionName
                                      | IsValueExist
                                  }}
                                </div>
                              </li>
                              <li>
                                <div>Census Track Id:</div>
                                <div class="propertyDetailsSectionValue">
                                  {{ activePropertyDetails.CensusTractId | IsValueExist }}
                                </div>
                              </li>
                              <li>
                                <div>Municipality:</div>
                                <div class="propertyDetailsSectionValue">
                                  {{ activePropertyDetails.Municipality | IsValueExist }}
                                </div>
                              </li>
                              <li>
                                <div>Lot:</div>
                                <div class="propertyDetailsSectionValue">
                                  {{ activePropertyDetails.TaxLotList | IsValueExist }}
                                </div>
                              </li>
                              <li>
                                <div>Block:</div>
                                <div class="propertyDetailsSectionValue">
                                  {{ activePropertyDetails.TaxBlock | IsValueExist }}
                                </div>
                              </li>
                              <li>
                                <div>Section:</div>
                                <div class="propertyDetailsSectionValue">
                                  {{ activePropertyDetails.TaxSection | IsValueExist }}
                                </div>
                              </li>
                              <li>
                                <div>Zoning:</div>
                                <div class="propertyDetailsSectionValue">
                                  {{ activePropertyDetails.Zoning | IsValueExist }}
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <hr />

                      <!-- Interior Features -->

                      <div
                        class="propertCharacter"
                        *ngIf="
                          (propertyInfo?.PropertySubType || activePropertyDetails?.PropertySubType) != 'Other Land'
                        "
                      >
                        <div class="row">
                          <div class="col-lg-12">
                            <h6 class="my-3 headWrap">Interior Features</h6>
                            <div class="row">
                              <ul class="pl-0 w-50" style="padding-right: 10px">
                                <li class="Interior-ul">
                                  <div class="property">Rooms:</div>
                                  <ul>
                                    <li>
                                      Bedrooms:
                                      <span>
                                        {{
                                          propertyInfo?.PropertyType === 'Land' ||
                                          activePropertyDetails?.PropertyType === 'Land'
                                            ? '--'
                                            : listingData.BedroomsTotal ||
                                              propertyInfo?.BedroomsTotal ||
                                              activePropertyDetails.BedroomsTotal ||
                                              '--'
                                        }}
                                      </span>
                                    </li>
                                    <li>
                                      Full Bathrooms:
                                      <span>
                                        {{
                                          propertyInfo?.PropertyType === 'Land' ||
                                          activePropertyDetails?.PropertyType === 'Land'
                                            ? '--'
                                            : (listingData.BathroomsFull ||
                                                propertyInfo?.BathroomsFull ||
                                                activePropertyDetails.BathroomsFull | IsValueExist)
                                        }}
                                      </span>
                                    </li>
                                    <li>
                                      Half Bathrooms:
                                      <span>
                                        {{
                                          propertyInfo?.PropertyType === 'Land' ||
                                          activePropertyDetails?.PropertyType === 'Land'
                                            ? '--'
                                            : (listingData.BathroomsHalf ||
                                                propertyInfo?.BathroomsPartial ||
                                                activePropertyDetails.BathroomsPartial | IsValueExist)
                                        }}
                                      </span>
                                    </li>
                                    <li>
                                      Total Rooms:
                                      <span>
                                        {{
                                          propertyInfo?.PropertyType === 'Land' ||
                                          activePropertyDetails?.PropertyType === 'Land'
                                            ? '--'
                                            : listingData.RoomsTotal || activePropertyDetails.RoomsTotal || '--'
                                        }}
                                      </span>
                                    </li>
                                  </ul>
                                </li>
                                <li class="Interior-ul">
                                  <div class="property">Fireplaces:</div>
                                  <ul>
                                    <li *ngIf="activePropertyDetails.FireplacesTotal || listingData.FireplacesTotal">
                                      Number of Fireplaces:
                                      <span class="propertyDetailsSectionValue">{{
                                        listingData.FireplacesTotal || activePropertyDetails.FireplacesTotal || '--'
                                      }}</span>
                                    </li>
                                    <li *ngIf="!listingData.FireplacesTotal && !activePropertyDetails.FireplacesTotal">
                                      Fireplaces:
                                      <span>{{ listingData.FireplaceYN === 'Y' ? 'Yes' : 'No' }}</span>
                                    </li>
                                    <li>
                                      Fireplace Features:
                                      <span class="propertyDetailsSectionValue">{{
                                        listingData.FireplaceFeatures | IsValueExist
                                      }}</span>
                                    </li>
                                  </ul>
                                </li>
                                <li class="Interior-ul">
                                  <div class="property">Area:</div>
                                  <ul>
                                    <li>
                                      Living Area:
                                      <span
                                        class="propertyDetailsSectionValue"
                                        *ngIf="
                                          propertyInfo?.LivingArea ||
                                          activePropertyDetails.LivingArea ||
                                          listingData.LivingArea
                                        "
                                      >
                                        {{
                                          propertyInfo?.PropertyType === 'Land' ||
                                          activePropertyDetails?.PropertyType === 'Land'
                                            ? '--'
                                            : (listingData.LivingArea ||
                                                propertyInfo?.LivingArea ||
                                                activePropertyDetails.LivingArea) + ' sq.ft'
                                        }}
                                      </span>
                                      <span
                                        *ngIf="
                                          !listingData.LivingArea &&
                                          !activePropertyDetails.LivingArea &&
                                          !propertyInfo?.LivingArea
                                        "
                                      >
                                        --
                                      </span>
                                    </li>
                                    <li>
                                      Building Area:
                                      <span
                                        class="propertyDetailsSectionValue"
                                        *ngIf="activePropertyDetails.BuildingAreaTotal"
                                      >
                                        {{
                                          propertyInfo?.PropertyType === 'Land' ||
                                          activePropertyDetails?.PropertyType === 'Land'
                                            ? '--'
                                            : activePropertyDetails.BuildingAreaTotal + ' sq.ft'
                                        }}
                                      </span>
                                      <span *ngIf="!activePropertyDetails.BuildingAreaTotal">--</span>
                                    </li>
                                    <li>
                                      Garage Area:
                                      <span
                                        class="propertyDetailsSectionValue"
                                        *ngIf="activePropertyDetails.GarageArea"
                                      >
                                        {{
                                          propertyInfo?.PropertyType === 'Land' ||
                                          activePropertyDetails?.PropertyType === 'Land'
                                            ? '--'
                                            : activePropertyDetails.GarageArea + ' sq.ft'
                                        }}
                                      </span>
                                      <span *ngIf="!activePropertyDetails.GarageArea">--</span>
                                    </li>
                                  </ul>
                                </li>
                                <li class="Interior-ul">
                                  <div class="property">Basement:</div>
                                  <ul>
                                    <li>
                                      <span class="propertyDetailsSectionValue" *ngIf="listingData.Basement">
                                        {{ listingData.Basement }}</span
                                      >
                                      <span class="propertyDetailsSectionValue" *ngIf="listingData.BasementEntry">
                                        {{ listingData.BasementEntry }}</span
                                      >
                                      <span class="propertyDetailsSectionValue" *ngIf="listingData.BasementType">
                                        {{ listingData.BasementType }}</span
                                      >
                                      <span
                                        *ngIf="
                                          !!listingData.Basement ||
                                          !!listingData.BasementEntry ||
                                          !!listingData.BasementType
                                        "
                                      >
                                        --
                                      </span>
                                    </li>
                                    <li>
                                      Total Area:
                                      <span
                                        class="propertyDetailsSectionValue"
                                        *ngIf="
                                          activePropertyDetails.BelowGradeTotalArea || listingData.BelowGradeTotalArea
                                        "
                                      >
                                        {{
                                          listingData.BelowGradeTotalArea ||
                                            activePropertyDetails.BelowGradeTotalArea +
                                              '
                                    sq.ft'
                                        }}
                                      </span>
                                      <span
                                        *ngIf="
                                          !activePropertyDetails.BelowGradeTotalArea && !listingData.BelowGradeTotalArea
                                        "
                                      >
                                        --
                                      </span>
                                    </li>
                                    <li>
                                      Finished Area:
                                      <span
                                        class="propertyDetailsSectionValue"
                                        *ngIf="
                                          listingData.BelowGradeFinishedAreaUnits &&
                                          !activePropertyDetails.BelowGradeFinishedArea
                                        "
                                      >
                                        {{ listingData.BelowGradeFinishedArea }}
                                        {{
                                          listingData.BelowGradeFinishedAreaUnits
                                            ? ' ' + listingData.BelowGradeFinishedAreaUnits
                                            : ' sq.ft'
                                        }}
                                      </span>
                                      <span
                                        *ngIf="
                                          !listingData.BelowGradeFinishedAreaUnits &&
                                          activePropertyDetails.BelowGradeFinishedArea
                                        "
                                      >
                                        {{ activePropertyDetails.BelowGradeFinishedArea + ' sq.ft' }}
                                      </span>
                                      <span
                                        *ngIf="
                                          !activePropertyDetails.BelowGradeFinishedArea &&
                                          !listingData.BelowGradeFinishedArea
                                        "
                                      >
                                        --
                                      </span>
                                    </li>
                                  </ul>
                                </li>
                              </ul>
                              <ul class="pl-0 w-50 other-details" style="padding-right: 10px">
                                <li *ngIf="!isAvoidListing">
                                  <div>Appliances:</div>
                                  <div class="propertyDetailsSectionValue">
                                    {{ listingData.Appliances | IsValueExist }}
                                  </div>
                                </li>
                                <li *ngIf="!isAvoidListing">
                                  <div>Interior Features:</div>
                                  <div class="propertyDetailsSectionValue">
                                    {{ listingData.InteriorFeatures | IsValueExist }}
                                  </div>
                                </li>
                                <li>
                                  <div>Heating:</div>
                                  <div class="propertyDetailsSectionValue">
                                    {{
                                      propertyInfo?.PropertyType === 'Land' ||
                                      activePropertyDetails?.PropertyType === 'Land'
                                        ? '--'
                                        : listingData.Heating && listingData.HeatingType
                                        ? listingData.Heating + ',' + listingData.HeatingType
                                        : listingData.Heating ||
                                          listingData.HeatingType ||
                                          activePropertyDetails.Heating ||
                                          '--'
                                    }}
                                  </div>
                                </li>
                                <li>
                                  <div>Cooling:</div>
                                  <div class="propertyDetailsSectionValue">
                                    {{
                                      propertyInfo?.PropertyType === 'Land' ||
                                      activePropertyDetails?.PropertyType === 'Land'
                                        ? '--'
                                        : listingData.Cooling && listingData.CoolingType
                                        ? listingData.Cooling + ',' + listingData.CoolingType
                                        : listingData.Cooling ||
                                          listingData.CoolingType ||
                                          activePropertyDetails.Cooling ||
                                          '--'
                                    }}
                                  </div>
                                </li>
                                <li>
                                  <div>Flooring:</div>
                                  <div class="propertyDetailsSectionValue">
                                    {{ listingData.Flooring || activePropertyDetails.Flooring || '--' }}
                                  </div>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                      <hr />

                      <!-- Exterior Features -->

                      <div
                        class="propertCharacter"
                        *ngIf="
                          (propertyInfo?.PropertySubType || activePropertyDetails?.PropertySubType) != 'Other Land'
                        "
                      >
                        <div class="row">
                          <div class="col-lg-12">
                            <h6 class="my-3 headWrap">Exterior Features</h6>
                            <ul class="pl-0 w-100 prop_char" style="padding-right: 10px">
                              <li>
                                <div>Roof Description:</div>
                                <div class="propertyDetailsSectionValue">
                                  {{
                                    listingData.Roof ||
                                      (activePropertyDetails.RoofType && activePropertyDetails.RoofCoverType
                                        ? activePropertyDetails.RoofType + ',' + activePropertyDetails.RoofCoverType
                                        : activePropertyDetails.RoofType || activePropertyDetails.RoofCoverType || '--')
                                  }}
                                </div>
                              </li>
                              <li>
                                <div>Patio & Porch Features:</div>
                                <div class="propertyDetailsSectionValue">
                                  {{ listingData.PatioAndPorchFeatures | IsValueExist }}
                                </div>
                              </li>
                              <li>
                                <div>Pool Features:</div>
                                <div class="propertyDetailsSectionValue">
                                  {{
                                    listingData.PoolFeatures ||
                                      listingData.PoolType ||
                                      activePropertyDetails.PoolType ||
                                      '--'
                                  }}
                                </div>
                              </li>
                              <li>
                                <div>Pool Private YN:</div>
                                <div>{{ listingData.PoolPrivateYN | IsValueExist }}</div>
                              </li>
                              <li *ngIf="!isAvoidListing">
                                <div>Exterior Features:</div>
                                <div class="propertyDetailsSectionValue">
                                  {{ listingData.ExteriorFeatures | IsValueExist }}
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <hr />

                      <!-- Property/Lot Details -->

                      <div class="propertCharacter">
                        <div class="row">
                          <div class="col-lg-12">
                            <h6 class="my-3 headWrap">Property/Lot Details</h6>
                            <ul class="pl-0 w-100 prop_char" style="padding-right: 10px">
                              <li>
                                <div>Property Type:</div>
                                <div class="propertyDetailsSectionValue">
                                  {{
                                    listingData.PropertySubType ||
                                      propertyInfo?.PropertySubType ||
                                      activePropertyDetails.PropertySubType ||
                                      '--'
                                  }}
                                </div>
                              </li>
                              <li>
                                <div>Subdivision Name:</div>
                                <div class="propertyDetailsSectionValue">
                                  {{
                                    listingData.SubdivisionName || activePropertyDetails.LegalSubdivisionName || '--'
                                  }}
                                </div>
                              </li>
                              <li
                                *ngIf="
                                  (propertyInfo?.PropertySubType || activePropertyDetails?.PropertySubType) !=
                                  'Other Land'
                                "
                              >
                                <div>Association YN:</div>
                                <div class="propertyDetailsSectionValue">
                                  {{ listingData.AssociationYN === 'Y' ? 'Yes' : 'No' }}
                                </div>
                              </li>
                              <li
                                *ngIf="
                                  (propertyInfo?.PropertySubType || activePropertyDetails?.PropertySubType) !=
                                  'Other Land'
                                "
                              >
                                <div>Association Name:</div>
                                <div class="propertyDetailsSectionValue">
                                  {{ listingData.AssociationName | IsValueExist }}
                                </div>
                              </li>
                              <li
                                *ngIf="
                                  !isAvoidListing &&
                                  (propertyInfo?.PropertySubType || activePropertyDetails?.PropertySubType) !=
                                    'Other Land'
                                "
                              >
                                <div>Association Fee:</div>
                                <div>{{ listingData.AssociationFee | CurrencyFormatter | IsValueExist }}</div>
                              </li>
                              <li
                                *ngIf="
                                  (propertyInfo?.PropertySubType || activePropertyDetails?.PropertySubType) !=
                                  'Other Land'
                                "
                              >
                                <div>Association Fee Frequency:</div>
                                <div class="propertyDetailsSectionValue">
                                  {{ listingData.AssociationFeeFrequency | CurrencyFormatter | IsValueExist }}
                                </div>
                              </li>
                              <li
                                *ngIf="
                                  (propertyInfo?.PropertySubType || activePropertyDetails?.PropertySubType) !=
                                  'Other Land'
                                "
                              >
                                <div>Association Fee Includes:</div>
                                <div class="propertyDetailsSectionValue">
                                  {{ listingData.AssociationFeeIncludes | IsValueExist }}
                                </div>
                              </li>
                              <li
                                *ngIf="
                                  (propertyInfo?.PropertySubType || activePropertyDetails?.PropertySubType) !=
                                  'Other Land'
                                "
                              >
                                <div>Architectural Style:</div>
                                <div class="propertyDetailsSectionValue">
                                  {{
                                    listingData.ArchitecturalStyle || activePropertyDetails.ArchitecturalStyle || '--'
                                  }}
                                </div>
                              </li>
                              <li
                                *ngIf="
                                  (propertyInfo?.PropertySubType || activePropertyDetails?.PropertySubType) !=
                                  'Other Land'
                                "
                              >
                                <div>Garage YN:</div>
                                <div>
                                  {{
                                    listingData.GarageYN
                                      ? listingData.GarageYN == 'Y'
                                        ? 'Yes'
                                        : 'No'
                                      : activePropertyDetails.GarageArea
                                      ? 'Yes'
                                      : 'No'
                                  }}
                                </div>
                              </li>
                              <li
                                *ngIf="
                                  (propertyInfo?.PropertySubType || activePropertyDetails?.PropertySubType) !=
                                  'Other Land'
                                "
                              >
                                <div>Attached Garage YN:</div>
                                <div>{{ listingData.AttachedGarageYN === 'Y' ? 'Yes' : 'No' }}</div>
                              </li>
                              <li
                                *ngIf="
                                  (propertyInfo?.PropertySubType || activePropertyDetails?.PropertySubType) !=
                                  'Other Land'
                                "
                              >
                                <div>Garage Spaces:</div>
                                <div class="propertyDetailsSectionValue">
                                  {{ listingData.GarageSpaces | IsValueExist }}
                                </div>
                              </li>
                              <li
                                *ngIf="
                                  (propertyInfo?.PropertySubType || activePropertyDetails?.PropertySubType) !=
                                  'Other Land'
                                "
                              >
                                <div>Parking Spaces:</div>
                                <div>
                                  {{ propertyInfo?.ParkingSpaces || activePropertyDetails.ParkingSpaces || '--' }}
                                </div>
                              </li>
                              <li
                                *ngIf="
                                  (propertyInfo?.PropertySubType || activePropertyDetails?.PropertySubType) !=
                                  'Other Land'
                                "
                              >
                                <div>Year Built:</div>
                                <div>{{ listingData.YearBuilt || activePropertyDetails.YearBuilt || '--' }}</div>
                              </li>
                              <li
                                *ngIf="
                                  (propertyInfo?.PropertySubType || activePropertyDetails?.PropertySubType) !=
                                  'Other Land'
                                "
                              >
                                <div>Year Built Effective:</div>
                                <div>{{ activePropertyDetails.YearBuiltEffective | IsValueExist }}</div>
                              </li>
                              <li>
                                <div>Lot Size(sq.ft):</div>
                                <div
                                  class="propertyDetailsSectionValue"
                                  *ngIf="
                                    listingData.LotSizeSquareFeet ||
                                    activePropertyDetails.LotSizeSquareFeet ||
                                    listingData.LotSizeSquareFeet
                                  "
                                >
                                  {{
                                    (listingData.LotSizeSquareFeet ||
                                      activePropertyDetails.LotSizeSquareFeet ||
                                      propertyInfo?.LotSizeSquareFeet) + ' sq.ft'
                                  }}
                                </div>
                                <div
                                  *ngIf="
                                    !listingData.LotSizeSquareFeet &&
                                    !activePropertyDetails.LotSizeSquareFeet &&
                                    !listingData.LotSizeSquareFeet
                                  "
                                >
                                  --
                                </div>
                              </li>
                              <li>
                                <div>Lot Size(Acres):</div>
                                <div class="propertyDetailsSectionValue">
                                  {{ listingData.LotSizeAcres || activePropertyDetails.LotSizeAcres || '--' }}
                                </div>
                              </li>
                              <li>
                                <div>Lot Size Dimensions:</div>
                                <div class="propertyDetailsSectionValue">
                                  {{ listingData.LotSizeDimensions || activePropertyDetails.LotSizeDimensions || '--' }}
                                </div>
                              </li>
                              <li>
                                <div>Senior Community YN:</div>
                                <div>{{ listingData.SeniorCommunityYN === 'Y' ? 'Yes' : 'No' }}</div>
                              </li>
                              <li>
                                <div>Assessors Map Reference:</div>
                                <div class="propertyDetailsSectionValue">
                                  {{ activePropertyDetails.AssessorsMapReference | IsValueExist }}
                                </div>
                              </li>
                              <li>
                                <div>Lot Features:</div>
                                <div class="propertyDetailsSectionValue">
                                  {{ listingData.LotFeatures | IsValueExist }}
                                </div>
                              </li>
                              <li class="w-100" *ngIf="RawMlsStatus == 'Closed'">
                                <div>Bought with:</div>
                                <div
                                  class="propertyDetailsSectionValue"
                                  *ngIf="
                                    !listingData.BuyerOfficeName && !listingData.BuyerOfficeEmail;
                                    else noListingAgentInfo
                                  "
                                >
                                  --
                                </div>
                                <ng-template #noListingAgentInfo>
                                  <div style="word-wrap: break-word; font-weight: 400">
                                    {{ listingData.BuyerOfficeName | IsValueExist }}
                                    {{
                                      listingData.BuyerOfficeEmail
                                        ? ', Contact: ' + (listingData.BuyerOfficeEmail | IsValueExist)
                                        : ''
                                    }}
                                  </div>
                                </ng-template>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <hr />

                      <!-- Property Transaction History -->

                      <div class="propertCharacter">
                        <div class="row">
                          <div class="col-lg-12">
                            <mat-accordion class="subSection">
                              <mat-expansion-panel [expanded]="true">
                                <mat-expansion-panel-header>
                                  <mat-panel-title>
                                    <h6 class="my-3 headWrap">Property Transaction History</h6>
                                  </mat-panel-title>
                                </mat-expansion-panel-header>
                                <div>
                                  <div
                                    *ngIf="
                                      activeTransactionHistory && activeTransactionHistory.length > 0;
                                      else noTransactionHistory
                                    "
                                  >
                                    <div class="timeline-container">
                                      <div class="timeline-item" *ngFor="let event of activeTransactionHistory">
                                        <div class="timeline-p">
                                          <div class="timeline-item-content">
                                            <h4>{{ event.TransactionContractDate | date: 'mediumDate' }}</h4>
                                            <div class="transaction-details">
                                              <div><b>Transaction Type:</b> {{ event.TransactionType }}</div>
                                              <div>
                                                <b>Close Price:</b>
                                                {{ event.ClosePrice | currency: 'USD':'symbol':'1.0-0' }}
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <ng-template #noTransactionHistory>
                                    <div class="flex_center notFound text-center mt-3 mb-3">
                                      <div>
                                        <h4>No property transaction history available</h4>
                                      </div>
                                    </div>
                                  </ng-template>
                                  <div class="text-center mt-2" style="font-style: italic; color: gray">
                                    Transaction Data source:
                                    {{ activeCountyValue && activeCountyValue != '--' ? activeCountyValue : 'County' }}
                                    Assessor
                                  </div>
                                </div>
                              </mat-expansion-panel>
                            </mat-accordion>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr />

                  <div></div>

                  <!-- Value and Tax Information -->

                  <div class="sectioninfo mt-4" id="value-tax-info" [ngStyle]="onScrollEvent">
                    <h4 class="headTitle">
                      <img src="../../../assets/images/taxInfo.svg" width="18" class="mr-2" /> Value and Tax Information
                    </h4>

                    <!-- Tax Information -->

                    <div class="row">
                      <div class="col-lg-12">
                        <h6 class="my-3 headWrap">Tax Information</h6>
                        <ul class="pl-0 w-100 prop_char">
                          <li>
                            <div>Tax Year:</div>
                            <div>{{ activePropertyDetails.TaxYear | IsValueExist }}</div>
                          </li>
                          <li>
                            <div>Annual Taxes:</div>
                            <div>
                              {{ activePropertyDetails.TaxAnnualAmount | CurrencyFormatter | IsValueExist }}
                            </div>
                          </li>
                          <li>
                            <div>Tax Exemption Status:</div>
                            <div class="propertyDetailsSectionValue">--</div>
                          </li>
                          <li>
                            <div>Tax District:</div>
                            <div class="propertyDetailsSectionValue">
                              {{ activePropertyDetails.TaxDistrict | IsValueExist }}
                            </div>
                          </li>
                        </ul>
                        <ul class="pl-0 w-100 prop_char">
                          <li>
                            <div>Assessed Year:</div>
                            <div>{{ activePropertyDetails.AssessedYear | IsValueExist }}</div>
                          </li>
                          <li>
                            <div>Assessed Value:</div>
                            <div class="propertyDetailsSectionValue">
                              {{ activePropertyDetails.AssessedValue | CurrencyFormatter | IsValueExist }}
                            </div>
                          </li>
                          <li>
                            <div class="propertyDetailsSectionValue">Assessed Improvement Value:</div>
                            <div>
                              {{ activePropertyDetails.AssessedImprovementValue | CurrencyFormatter | IsValueExist }}
                            </div>
                          </li>
                          <li>
                            <div class="propertyDetailsSectionValue">Assessed Land Value:</div>
                            <div>
                              {{ activePropertyDetails.AssessedLandValue | CurrencyFormatter | IsValueExist }}
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <hr />

                    <!-- Ownership Information -->

                    <div class="row">
                      <div class="col-lg-12">
                        <h6 class="my-3 headWrap">Ownership Information</h6>
                        <ul class="pl-0 w-100 prop_char">
                          <li>
                            <div>Owner Occupied:</div>
                            <div class="propertyDetailsSectionValue">
                              {{ activePropertyDetails.OwnerOccupied | IsValueExist | YesOrNoConverter }}
                            </div>
                          </li>
                          <li>
                            <div>Owned by Corporation:</div>
                            <div class="propertyDetailsSectionValue">
                              {{
                                (activePropertyDetails.Owner1IsCorporation
                                  ? activePropertyDetails.Owner1IsCorporation
                                  : activePropertyDetails.Owner2IsCorporation
                                )
                                  | IsValueExist
                                  | YesOrNoConverter
                              }}
                            </div>
                          </li>
                          <li>
                            <div>Owned Since:</div>
                            <div class="propertyDetailsSectionValue">
                              {{ activePropertyDetails.LastSaleContractDate | date: 'mediumDate' | IsValueExist }}
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <hr />

                    <!-- Valuation -->

                    <div class="row">
                      <div class="col-lg-12">
                        <h6 class="my-3 headWrap">Valuation</h6>
                        <ul class="pl-0 w-100 prop_char">
                          <li
                            *ngIf="
                              appState?.appCompanyAliasValue != 'opscan' &&
                              activeAVMHistory &&
                              activeAVMHistory.length > 0 &&
                              listingData.MlsBoard != 'MREIS' &&
                              companyName != 'valuetest'
                            "
                          >
                            <div>Current Value:</div>
                            <div>{{ activeAVMHistory[0].AVMValue | CurrencyFormatter | IsValueExist }}</div>
                          </li>

                          <li
                            *ngIf="
                              appState?.appCompanyAliasValue != 'opscan' &&
                              (propertyInfo?.PropertySubType || activePropertyDetails?.PropertySubType) != 'Other Land'
                            "
                          >
                            <div>Rent Value</div>
                            <div
                              [innerHTML]="
                                propertyInfo?.RentValue || activePropertyDetails?.RentValue
                                  | CurrencyFormatter
                                  | IsValueExist
                              "
                            ></div>
                          </li>

                          <li *ngIf="activeAVMHistory && activeAVMHistory.length > 0 && companyName != 'valuetest'">
                            <div>Value Range:</div>
                            <div class="propertyDetailsSectionValue">
                              {{ activeAVMHistory[0].AVMLowValue | CurrencyFormatter | IsValueExist }} -
                              {{ activeAVMHistory[0].AVMHighValue | CurrencyFormatter | IsValueExist }}
                            </div>
                          </li>

                          <li *ngIf="propertyInfo?.CapRate || activePropertyDetails.CapRate">
                            <div>Cap Rate</div>
                            <div [innerHTML]="(propertyInfo?.CapRate || activePropertyDetails.CapRate) + '%'"></div>
                          </li>
                          <li *ngIf="propertyInfo?.rebateAmount">
                            <div>Cash Back</div>
                            <div class="propertyDetailsSectionValue" class="rebate">
                              ${{ propertyInfo?.rebateAmount | number }}
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>

                    <!-- AVM History -->

                    <div class="row">
                      <div class="col-lg-12">
                        <h6 class="my-3">Property Value</h6>
                        <div>
                          <div
                            id="avmChart"
                            *ngIf="AVMHistoryDetails && AVMHistoryDetails.length > 0; else noAVMHistory"
                          >
                            <app-area-chart [avmData]="AVMHistoryDetails"></app-area-chart>
                          </div>

                          <ng-template #noAVMHistory>
                            <div class="flex_center notFound text-center mt-3 mb-3">
                              <div>
                                <h4>No property value history available</h4>
                              </div>
                            </div>
                          </ng-template>
                          <div class="text-center mt-2" style="font-style: italic; color: gray">
                            Valuation data is provided by PropMix.io, LLC
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr />

                  <!-- Equity and Mortgage Information -->

                  <div class="sectioninfo mt-4" *ngIf="authorizeService.canView('mortgages')">
                    <h4 class="headTitle">
                      <img src="../../../assets/images/mortgageInfo.svg" class="mr-2" width="22" />Equity and Mortgage
                      Information
                    </h4>
                    <div class="row">
                      <div class="col-lg-12">
                        <h6 class="my-3 headWrap">Net Equity</h6>
                        <ul class="pl-0 w-100 prop_char">
                          <li *ngIf="activeAVMHistory && activeAVMHistory.length > 0">
                            <div>Current Value:</div>
                            <div>{{ activeAVMHistory[0].AVMValue | CurrencyFormatter | IsValueExist }}</div>
                          </li>
                          <li>
                            <div>Est. Total Loan Balance:</div>
                            <div class="propertyDetailsSectionValue">
                              {{ totalLoanBalanceAtMonthEnd | CurrencyFormatter | IsValueExist }}
                            </div>
                          </li>
                          <li>
                            <div>Net Equity:</div>
                            <div>{{ totalOwnerEquity | CurrencyFormatter | IsValueExist }}</div>
                          </li>
                          <li>
                            <div>Estimated LTV:</div>
                            <div class="propertyDetailsSectionValue">{{ estimatedLtv }}</div>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <hr />

                    <!-- Mortgage Information -->

                    <div class="row">
                      <div class="col-lg-12">
                        <h6 class="my-3 headWrap">Mortgage Information</h6>
                        <div *ngIf="activeMortgageHistory && activeMortgageHistory.length > 0; else noMortgageHistory">
                          <mat-tab-group>
                            <div *ngFor="let mortgage of activeMortgageHistory | slice: 0:4; let i = index">
                              <mat-tab>
                                <ng-template mat-tab-label> {{ i + 1 | NumberToTextConverter }} Mortgage </ng-template>
                                <ul class="pl-0 w-100 prop_char mt-3">
                                  <li>
                                    <div>Principal Amount:</div>
                                    <div>{{ mortgage.MortgagePrincipal | CurrencyFormatter | IsValueExist }}</div>
                                  </li>
                                  <li>
                                    <div>Interest Rate:</div>
                                    <div>{{ mortgage.MortgageRate | number | IsValueExist }}%</div>
                                  </li>
                                  <li>
                                    <div>Loan Term:</div>
                                    <div>{{ mortgage.MortgageTerm | IsValueExist }}</div>
                                  </li>
                                  <li>
                                    <div>Loan Date:</div>
                                    <div>
                                      {{
                                        (mortgage.MortgageDocumentDate
                                          ? mortgage.MortgageDocumentDate
                                          : mortgage.MortgageRecordingDate
                                        )
                                          | date: 'mediumDate'
                                          | IsValueExist
                                      }}
                                    </div>
                                  </li>
                                  <li>
                                    <div>Mortgage Type:</div>
                                    <div class="propertyDetailsSectionValue">
                                      {{ mortgage.MortgageLoanType | IsValueExist }}
                                    </div>
                                  </li>
                                  <li>
                                    <div>Est. Loan Balance:</div>
                                    <div>{{ mortgage.LoanBalanceAtMonthEnd | CurrencyFormatter | IsValueExist }}</div>
                                  </li>
                                  <li>
                                    <div>Est. Monthly Payment:</div>
                                    <div>{{ mortgage.MonthlyEMI | CurrencyFormatter | IsValueExist }}</div>
                                  </li>
                                  <li>
                                    <div>Lender:</div>
                                    <div class="propertyDetailsSectionValue">
                                      {{ mortgage.MortgageLenderName | IsValueExist }}
                                    </div>
                                  </li>
                                </ul>
                              </mat-tab>
                            </div>
                          </mat-tab-group>
                        </div>
                        <ng-template #noMortgageHistory>
                          <div class="flex_center notFound text-center mt-3 mb-3">
                            <div>
                              <h4>No mortgage information available</h4>
                            </div>
                          </div>
                        </ng-template>
                      </div>
                    </div>
                  </div>
                  <hr />
                  <div
                    *ngIf="
                      propertyInfo &&
                      propertyInfo?.Lst_StandardStatus !== 'Active' &&
                      propertyInfo?.Lst_StandardStatus !== 'Active Under Contract' &&
                      propertyInfo.Lst_StandardStatus !== 'Pending' &&
                      listingData.StandardStatus != 'Pending' &&
                      listingData.StandardStatus != 'Active' &&
                      listingData.StandardStatus != 'Active Under Contract'
                    "
                  ></div>
                  <hr />

                  <hr />

                  <!-- School Information -->

                  <div class="sectioninfo mt-2" id="schools" #schools [ngStyle]="onScrollEvent">
                    <div class="row">
                      <div class="col-lg-12">
                        <mat-accordion>
                          <mat-expansion-panel
                            class="expand-head"
                            (opened)="getSchoolDistrictsForProperty()"
                            (closed)="onCloseSchoolInfo()"
                            (afterExpand)="scroll('schools')"
                            #schools
                          >
                            <mat-expansion-panel-header>
                              <mat-panel-title>
                                <h4 class="headTitle">
                                  <img src="../../../assets/images/schoolInfo.svg" class="mr-2" width="22" /> School
                                  Information
                                </h4>
                              </mat-panel-title>
                            </mat-expansion-panel-header>
                            <div *ngIf="schoolsForPropertyLoaderStatus">
                              <div class="flex_center fullHeight">
                                <mat-spinner [diameter]="30" class="mr-3"></mat-spinner> Please wait while we load
                              </div>
                            </div>
                            <div class="schoolInfo" *ngIf="!schoolsForPropertyLoaderStatus">
                              <div
                                *ngIf="activeSchoolDistrictsForProperty && activeSchoolDistrictsForProperty.length > 0"
                              >
                                <p class="mb-1">School District Names:</p>
                                <mat-chip-list aria-label="School Districts">
                                  <div *ngFor="let district of activeSchoolDistrictsForProperty">
                                    <mat-chip color="primary" selected>
                                      <span class="badge" *ngIf="district.DistrictType && district.DistrictType != ''">
                                        {{ district.DistrictType.charAt(0) }}
                                      </span>
                                      {{ district.SchoolDistrictName }}
                                    </mat-chip>
                                  </div>
                                </mat-chip-list>
                                <div *ngIf="activeSchoolsForProperty && activeSchoolsForProperty.length > 0">
                                  <div class="row">
                                    <mat-card class="col-sm-6" *ngFor="let school of activeSchoolsForProperty">
                                      <ul>
                                        <li>
                                          <h4>{{ school.SchoolName }}</h4>
                                        </li>
                                        <li>
                                          <img src="../../../assets/images/mapPin.svg" width="16" />
                                          <span class="ml-1"
                                            >{{ school.StreetAddress1 }} {{ school.City }} {{ school.StateOrProvince }}
                                            {{ school.PostalCode }}</span
                                          >
                                        </li>
                                        <li>
                                          <img src="../../../assets/images/phone.svg" width="13" />
                                          <span class="ml-1">{{ school.ContactPhone }}</span>
                                        </li>
                                        <li>
                                          <img src="../../../assets/images/schoolCap.svg" width="16" />
                                          <span class="ml-1">{{ school.SchoolGradeLevel }}</span>
                                        </li>
                                        <li class="schoolType">
                                          <img src="../../../assets/images/schoolType.svg" width="40" />
                                          <div [ngClass]="{ pvt: school.PublicOrPrivate === 'Private School' }">
                                            {{ school.PublicOrPrivate }}
                                          </div>
                                        </li>
                                      </ul>
                                    </mat-card>
                                  </div>
                                </div>
                              </div>
                              <div class="text-center mt-2" style="font-style: italic; color: gray">
                                School data source: National Center for Educational Statistics (NCES)
                              </div>
                            </div>
                          </mat-expansion-panel>
                        </mat-accordion>
                      </div>
                    </div>
                  </div>

                  <!-- Local Trends -->

                  <div class="sectioninfo mt-5" id="trends" [ngStyle]="onScrollEvent">
                    <div class="row">
                      <div class="col-lg-12">
                        <mat-accordion>
                          <mat-expansion-panel
                            (opened)="getLocalTrends(activePropertyDetails.PostalCode)"
                            (closed)="onCloseLocalTrends()"
                            (afterExpand)="scroll('localTrends')"
                            class="expand-head"
                            #localTrends
                          >
                            <mat-expansion-panel-header>
                              <mat-panel-title>
                                <h4 class="headTitle">
                                  <img src="../../../assets/images/trendsInfo.svg" class="mr-2" width="22" />
                                  Local Market Insights for
                                  {{
                                    (activePropertyDetails.PostalCode | IsValueExist) !== '--'
                                      ? activePropertyDetails.PostalCode
                                      : ''
                                  }}
                                </h4>
                              </mat-panel-title>
                            </mat-expansion-panel-header>
                            <div *ngIf="localTrendsLoaderStatus">
                              <div class="flex_center fullHeight">
                                <mat-spinner [diameter]="30" class="mr-3"></mat-spinner> Please wait while we load
                              </div>
                            </div>
                            <div *ngIf="!localTrendsLoaderStatus">
                              <p class="bold ml-3">Market Insights provided by PropMix.io LLC</p>
                              <iframe
                                *ngIf="activeLocalTrendsForZip"
                                [src]="activeLocalTrendsForZip"
                                height="2460"
                                width="100%"
                              ></iframe>
                            </div>
                          </mat-expansion-panel>
                        </mat-accordion>
                      </div>
                    </div>
                  </div>

                  <ng-template #distressedInfoContent>
                    <div class="common-div">
                      <div class="sectioninfo mt-5" id="more" [ngStyle]="onScrollEvent">
                        <h4 class="headTitle">
                          <img src="../../../assets/images/distressed_data.png" class="mr-2" width="22" />
                          <span
                            *ngIf="
                              ['Auction', 'Hudlisting', 'Pre-Foreclosure', 'Bankowned'].includes(
                                propertyInfo?.saletype
                              ) ||
                              ['Auction', 'Hudlisting', 'Pre-Foreclosure', 'Bankowned'].includes(
                                activePropertyDetails?.saletype
                              )
                            "
                          >
                            {{ propertyInfo?.saletype || activePropertyDetails?.saletype }} Details
                          </span>

                          <span
                            *ngIf="
                              ((propertyInfo?.saletype &&
                                propertyInfo?.saletype.includes(',') &&
                                propertyInfo?.saletype.includes('Auction')) ||
                                (activePropertyDetails?.saletype &&
                                  activePropertyDetails?.saletype.includes(',') &&
                                  activePropertyDetails?.saletype.includes('Auction'))) &&
                              isBeforeLastAuctionDate(
                                propertyInfo.Fcl_lastauctionDate || activePropertyDetails.Fcl_lastauctionDate
                              )
                            "
                          >
                            Auction Details</span
                          >

                          <span
                            *ngIf="
                              ((propertyInfo?.saletype &&
                                propertyInfo?.saletype.includes(',') &&
                                propertyInfo?.saletype.includes('Auction')) ||
                                (activePropertyDetails?.saletype &&
                                  activePropertyDetails?.saletype.includes(',') &&
                                  activePropertyDetails?.saletype.includes('Auction'))) &&
                              !isBeforeLastAuctionDate(
                                propertyInfo.Fcl_lastauctionDate || activePropertyDetails.Fcl_lastauctionDate
                              )
                            "
                          >
                            Distress Details</span
                          >
                        </h4>

                        <div
                          class="flex_center notFound text-center mt-3 mb-3"
                          *ngIf="!activeDistressedProperty || !distressedPropertyStatus; else noDistressInformation"
                        >
                          <div>
                            <h4>No distress information available</h4>
                          </div>
                        </div>

                        <ng-template #noDistressInformation>
                          <!-- Distress Information -->

                          <div class="row">
                            <div class="col-lg-12">
                              <h6 class="my-3 headWrap">Distress Information</h6>
                              <ul class="pl-0 w-100 prop_char">
                                <li>
                                  <div>Distress Status:</div>
                                  <div class="propertyDetailsSectionValue">
                                    {{ activeDistressedProperty.DistressStatus | IsValueExist }}
                                  </div>
                                </li>
                                <li>
                                  <div>Distress Start Date:</div>
                                  <div>
                                    {{ activeDistressedProperty.DistressStartDate | date: 'mediumDate' | IsValueExist }}
                                  </div>
                                </li>
                                <li>
                                  <div>Default Amount:</div>
                                  <div>
                                    {{ activeDistressedProperty.DefaultAmount | CurrencyFormatter | IsValueExist }}
                                  </div>
                                </li>
                                <li>
                                  <div>Escrow Amount:</div>
                                  <div>
                                    {{ activeDistressedProperty.EscrowAmount | CurrencyFormatter | IsValueExist }}
                                  </div>
                                </li>
                                <li>
                                  <div>Last Payment Amount:</div>
                                  <div>
                                    {{ activeDistressedProperty.LastPaymentAmount | CurrencyFormatter | IsValueExist }}
                                  </div>
                                </li>
                                <li></li>
                                <li>
                                  <div>Total Due Amount:</div>
                                  <div>
                                    {{ activeDistressedProperty.TotalDueAmount | CurrencyFormatter | IsValueExist }}
                                  </div>
                                </li>
                                <li>
                                  <div>Due Date:</div>
                                  <div>
                                    {{
                                      activeDistressedProperty.ForeclosureJudgementDate
                                        | date: 'mediumDate'
                                        | IsValueExist
                                    }}
                                  </div>
                                </li>
                              </ul>
                            </div>
                          </div>

                          <div
                            *ngIf="
                              (propertyInfo?.saletype &&
                                propertyInfo?.saletype.includes(',') &&
                                propertyInfo?.saletype.includes('Auction')) ||
                              (propertyInfo?.saletype && propertyInfo?.saletype == 'Auction') ||
                              (activePropertyDetails?.saletype &&
                                activePropertyDetails?.saletype.includes(',') &&
                                activePropertyDetails?.saletype.includes('Auction')) ||
                              (activePropertyDetails?.saletype && activePropertyDetails?.saletype == 'Auction')
                            "
                          >
                            <span
                              *ngIf="
                                isBeforeLastAuctionDate(
                                  propertyInfo.Fcl_lastauctionDate || activePropertyDetails.Fcl_lastauctionDate
                                )
                              "
                            >
                              <ng-container *ngTemplateOutlet="auctionInfoContent"></ng-container>
                            </span>
                          </div>

                          <!-- Mortgage Information -->

                          <div
                            class="row"
                            *ngIf="
                              ['Pre-Foreclosure'].includes(propertyInfo?.saletype) ||
                              ['Pre-Foreclosure'].includes(activePropertyDetails?.saletype) ||
                              propertyInfo?.Lst_speciallistingconditions == 'Short Sale' ||
                              activePropertyDetails?.Lst_speciallistingconditions == 'Short Sale'
                            "
                          >
                            <div class="col-lg-12">
                              <h6 class="my-3 headWrap">Mortgage Information</h6>
                              <ul class="pl-0 w-100 prop_char">
                                <li>
                                  <div>Lender Name:</div>
                                  <div class="propertyDetailsSectionValue">
                                    {{ activeDistressedProperty.MortgageLenderName | IsValueExist }}
                                  </div>
                                </li>
                                <li>
                                  <div>Principal:</div>
                                  <div class="propertyDetailsSectionValue">
                                    {{ activeDistressedProperty.MortgagePrincipal | CurrencyFormatter | IsValueExist }}
                                  </div>
                                </li>
                                <li>
                                  <div>Lender Address:</div>
                                  <div
                                    class="propertyDetailsSectionValue"
                                    *ngIf="
                                      (activeDistressedProperty.MortgageLenderStreetAddress | IsValueExist) === '--' &&
                                        (activeDistressedProperty.MortgageLenderCity | IsValueExist) === '--' &&
                                        (activeDistressedProperty.MortgageLenderStateOrProvince | IsValueExist) ===
                                          '--' &&
                                        (activeDistressedProperty.MortgageLenderPostalCode | IsValueExist) === '--';
                                      else noLenderAddress
                                    "
                                  >
                                    --
                                  </div>
                                  <ng-template #noLenderAddress>
                                    <div>
                                      {{ activeDistressedProperty.MortgageLenderStreetAddress | IsValueExist }},
                                      {{ activeDistressedProperty.MortgageLenderCity | IsValueExist }},
                                      {{ activeDistressedProperty.MortgageLenderStateOrProvince | IsValueExist }},
                                      {{ activeDistressedProperty.MortgageLenderPostalCode | IsValueExist }}
                                    </div>
                                  </ng-template>
                                </li>
                                <li>
                                  <div>Contract Date:</div>
                                  <div>
                                    {{
                                      activeDistressedProperty.MortgageContractDate | date: 'mediumDate' | IsValueExist
                                    }}
                                  </div>
                                </li>
                                <li>
                                  <div>Lender Contact:</div>
                                  <div class="propertyDetailsSectionValue">
                                    {{ activeDistressedProperty.MortgageLenderPhone | IsValueExist }}
                                  </div>
                                </li>
                                <li>
                                  <div>Balance:</div>
                                  <div>
                                    {{ activeDistressedProperty.MortgageBalance | CurrencyFormatter | IsValueExist }}
                                  </div>
                                </li>
                                <li>
                                  <div>Lender Notes:</div>
                                  <div class="propertyDetailsSectionValue">
                                    {{ activeDistressedProperty.MortgageLenderNotes | IsValueExist }}
                                  </div>
                                </li>
                                <li>
                                  <div>Document Id:</div>
                                  <div class="propertyDetailsSectionValue">
                                    {{ activeDistressedProperty.MortgageRecordingDocumentId | IsValueExist }}
                                  </div>
                                </li>
                                <li></li>
                                <li>
                                  <div>Book #:</div>
                                  <div class="propertyDetailsSectionValue">
                                    {{ activeDistressedProperty.MortgageRecordingBook | IsValueExist }}
                                  </div>
                                </li>
                                <li></li>
                                <li>
                                  <div>Page #:</div>
                                  <div class="propertyDetailsSectionValue">
                                    {{ activeDistressedProperty.MortgageRecordingPage | IsValueExist }}
                                  </div>
                                </li>
                              </ul>
                            </div>
                          </div>

                          <!-- Trustee Information -->

                          <div
                            class="row"
                            *ngIf="
                              propertyInfo?.Fcl_Status == 'AUCTION' ||
                              propertyInfo?.Lst_speciallistingconditions == 'Short Sale'
                            "
                          >
                            <div class="col-lg-12">
                              <h6 class="my-3 headWrap">Trustee Information</h6>
                              <ul class="pl-0 w-100 prop_char">
                                <li>
                                  <div>Name:</div>
                                  <div class="propertyDetailsSectionValue">
                                    {{ activeDistressedProperty.TrusteeName | IsValueExist }}
                                  </div>
                                </li>
                                <li>
                                  <div>Trustee File Number:</div>
                                  <div class="propertyDetailsSectionValue">
                                    {{ activeDistressedProperty.TrusteeFileNumber | IsValueExist }}
                                  </div>
                                </li>
                                <li>
                                  <div>Address:</div>
                                  <div
                                    class="propertyDetailsSectionValue"
                                    *ngIf="
                                      (activeDistressedProperty.TrusteeStreetAddress | IsValueExist) === '--' &&
                                        (activeDistressedProperty.TrusteeCity | IsValueExist) === '--' &&
                                        (activeDistressedProperty.TrusteeStateOrProvince | IsValueExist) === '--' &&
                                        (activeDistressedProperty.TrusteePostalCode | IsValueExist) === '--';
                                      else noTrusteeAddress
                                    "
                                  >
                                    --
                                  </div>
                                  <ng-template #noTrusteeAddress>
                                    <div>
                                      {{ activeDistressedProperty.TrusteeStreetAddress | IsValueExist }},
                                      {{ activeDistressedProperty.TrusteeCity | IsValueExist }},
                                      {{ activeDistressedProperty.TrusteeStateOrProvince | IsValueExist }},
                                      {{ activeDistressedProperty.TrusteePostalCode | IsValueExist }}
                                    </div>
                                  </ng-template>
                                </li>
                                <li></li>
                                <li>
                                  <div>Phone:</div>
                                  <div class="propertyDetailsSectionValue">
                                    {{ activeDistressedProperty.TrusteePhone | IsValueExist }}
                                  </div>
                                </li>
                              </ul>
                            </div>
                          </div>

                          <ng-template #auctionInfoContent>
                            <div class="row" *ngIf="auctionList && auctionList.length > 0">
                              <div class="col-lg-12">
                                <h6 class="my-3 headWrap">Auction Information</h6>
                                <div class="table_base">
                                  <div class="table-responsive table_wrap">
                                    <table
                                      mat-table
                                      [dataSource]="auctionList | slice: 0:limit"
                                      class="mat-elevation-z2 w-100"
                                    >
                                      <ng-container matColumnDef="slNo">
                                        <th mat-header-cell *matHeaderCellDef>No.</th>
                                        <td mat-cell *matCellDef="let element">
                                          {{ auctionList.indexOf(element) + 1 }}
                                        </td>
                                      </ng-container>
                                      <ng-container matColumnDef="Auction Date">
                                        <th mat-header-cell *matHeaderCellDef>Auction Date</th>
                                        <td mat-cell *matCellDef="let element">
                                          {{ element.AuctionDate | IsValueExist }}
                                        </td>
                                      </ng-container>
                                      <ng-container matColumnDef="Auction Time">
                                        <th mat-header-cell *matHeaderCellDef>Auction Time</th>
                                        <td mat-cell *matCellDef="let element">
                                          {{ element.AuctionTime | IsValueExist }}
                                        </td>
                                      </ng-container>
                                      <ng-container matColumnDef="Auction Site Address">
                                        <th mat-header-cell *matHeaderCellDef>Auction Site Address</th>
                                        <td mat-cell *matCellDef="let element">
                                          {{ element.AuctionSiteAddress | IsValueExist }}
                                        </td>
                                      </ng-container>
                                      <ng-container matColumnDef="Auction Site City">
                                        <th mat-header-cell *matHeaderCellDef>Auction Site City</th>
                                        <td mat-cell *matCellDef="let element">
                                          {{ element.AuctionSiteCity | IsValueExist }}
                                        </td>
                                      </ng-container>
                                      <ng-container matColumnDef="Auction Site Postal Code">
                                        <th mat-header-cell *matHeaderCellDef>Auction Site Postal Code</th>
                                        <td mat-cell *matCellDef="let element">
                                          {{ element.AuctionSitePostalCode | IsValueExist }}
                                        </td>
                                      </ng-container>
                                      <tr mat-header-row *matHeaderRowDef="auctionDisplayedColumns"></tr>
                                      <tr mat-row *matRowDef="let row; columns: auctionDisplayedColumns"></tr>
                                    </table>
                                  </div>
                                </div>
                                <div>
                                  <button
                                    mat-button
                                    *ngIf="auctionList.length > 1"
                                    (click)="toggle()"
                                    style="float: right"
                                  >
                                    View {{ showAuction ? 'less' : 'more' }}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </ng-template>
                        </ng-template>
                      </div>
                    </div>
                  </ng-template>
                </div>
              </div>

              <div class="col-sm-12 col-md-5 col-lg-4 m-none" *ngIf="companyName != 'valuetest'">
                <div class="propdetails_rightsec d-cta">
                  <mat-accordion multi="true">
                    <mat-expansion-panel
                      class="contact-agent"
                      [expanded]="true"
                      *ngIf="
                        ['active', 'pending', 'active under contract'].includes(
                          listingData?.StandardStatus?.toLowerCase() ||
                            propertyInfo?.Lst_StandardStatus?.toLowerCase() ||
                            activePropertyDetails?.Lst_StandardStatus?.toLowerCase()
                        ) && canViewAgentContactInfo
                      "
                    >
                      <mat-expansion-panel-header>
                        <mat-panel-title>
                          <h4 class="mb-0">Contact Agent</h4>
                        </mat-panel-title>
                      </mat-expansion-panel-header>
                      <app-agent-contact> </app-agent-contact>
                    </mat-expansion-panel>
                    <div *ngIf="enableCmaButton">
                      <button class="button-single" mat-flat-button color="primary" (click)="createCma()">
                        Create CMA
                      </button>
                    </div>
                    <div class="listed-by-card shadow-1">
                      <h4 class="section-title">
                        {{
                          propertyInfo?.Lst_StandardStatus === 'Sold' ||
                          propertyInfo?.Lst_StandardStatus === 'Cancel / withdrawn'
                            ? 'Sold By'
                            : 'Listed By'
                        }}
                      </h4>
                      <div>
                        <div class="info-row">
                          <div class="icon-box">
                            <span class="material-icons">person</span>
                          </div>
                          <div class="info-content">
                            <div class="info-value propertyDetailsSectionValue">
                              {{ listingData.ListAgentFullName || '--' }}
                            </div>
                          </div>
                        </div>

                        <div class="info-row">
                          <div class="icon-box">
                            <span class="material-icons">business</span>
                          </div>
                          <div class="info-content">
                            <div class="info-value propertyDetailsSectionValue">
                              {{ listingData.ListOfficeName || '--' }}
                            </div>
                          </div>
                        </div>

                        <div class="info-row">
                          <div class="icon-box">
                            <span class="material-icons">phone</span>
                          </div>
                          <div class="info-content">
                            <div class="info-value propertyDetailsSectionValue">
                              <div class="info-content">
                                <div class="info-value">
                                  {{
                                    listingData.InternetAttributionContact ||
                                      listingData.ListAgentPreferredPhone ||
                                      listingData.ListAgentCellPhone ||
                                      listingData.Lst_ListAgentPhone ||
                                      listingData.ListAgentOfficePhone ||
                                      listingData.ListOfficePhone ||
                                      '--'
                                  }}
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="icon-box">
                            <span class="material-icons">email</span>
                          </div>
                          <div class="info-content">
                            <div class="info-value propertyDetailsSectionValue">
                              {{
                                (listingData.MlsBoard === 'MREIS'
                                  ? listingData.ListOfficeEmail
                                  : listingData.ListAgentEmail) || '--'
                              }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="property-navigation-card" (click)="scrollTo('propertyAnalysis')">
                      <div class="property-icon">
                        <img src="../../../../assets/images/analyse.svg" />
                      </div>
                      <div class="property-content">
                        <div class="property-title">Investment Analysis</div>
                        <div class="property-description">See investment and development potential</div>
                      </div>
                      <div class="property-arrow">›</div>
                    </div>

                    <mat-expansion-panel
                      [expanded]="true"
                      *ngIf="
                        ['active', 'pending', 'active under contract'].includes(
                          listingData?.StandardStatus?.toLowerCase() ||
                            propertyInfo?.Lst_StandardStatus?.toLowerCase() ||
                            activePropertyDetails?.Lst_StandardStatus?.toLowerCase()
                        ) && canViewAgentContactInfo
                      "
                    >
                      <mat-expansion-panel-header>
                        <mat-panel-title>
                          <h4 class="mb-0">Payment Calculator</h4>
                        </mat-panel-title>
                      </mat-expansion-panel-header>
                      <p class="bold ml-3 mb-0">Calculator and Data provided by PropMix.io LLC</p>
                      <app-payment-calculator class="pt-4 pt-md-3 pt-lg-4"> </app-payment-calculator>
                    </mat-expansion-panel>

                    <mat-expansion-panel
                      class="contact-agent"
                      [expanded]="true"
                      *ngIf="!isMyHomeClicked && !isOffmarketProperty && canViewAgentContactInfo"
                    >
                      <mat-expansion-panel-header>
                        <mat-panel-title>
                          <h4 class="mb-0">Is this your home?</h4>
                        </mat-panel-title>
                      </mat-expansion-panel-header>
                      <p class="home-claim">Track this home's value with real time information</p>
                      <div class="btn-p">
                        <button
                          *ngIf="userType == 'investor' && !propertyInfo?.homeId && !activePropertyDetails?.homeId"
                          mat-flat-button
                          color="primary"
                          class="get-approved btn-block claim-btn"
                          (click)="answerQuestions()"
                        >
                          Claim your home
                        </button>
                        <button
                          *ngIf="propertyInfo?.homeId || activePropertyDetails?.homeId"
                          mat-flat-button
                          color="primary"
                          class="get-approved btn-block claim-btn"
                          (click)="manageMyProperty()"
                        >
                          Manage your home
                        </button>
                      </div>
                    </mat-expansion-panel>
                  </mat-accordion>
                </div>

                <br />
                <div class="propdetails_rightsec d-cta" *ngIf="isOffmarketProperty && displayCta">
                  <mat-accordion multi="true">
                    <mat-expansion-panel class="contact-agent" [expanded]="true">
                      <mat-expansion-panel-header>
                        <mat-panel-title>
                          <h4 class="mb-0">Is this your home?</h4>
                        </mat-panel-title>
                      </mat-expansion-panel-header>
                      <p class="home-claim">Track this home's value and nearby sales activity</p>
                      <div class="btn-p">
                        <button
                          mat-flat-button
                          color="primary"
                          class="get-approved btn-block claim-btn"
                          (click)="answerQuestions()"
                        >
                          Claim your home
                        </button>
                      </div>

                      <hr class="hr" />
                      <div class="btn-p">
                        <button
                          mat-stroked-button
                          color="primary"
                          class="get-approved mr-3 btn-block claim-btn"
                          (click)="openContactConsultant()"
                        >
                          Request a selling agent
                        </button>
                      </div>
                    </mat-expansion-panel>
                  </mat-accordion>
                </div>
                <br />
                <div></div>
              </div>
            </div>
            <app-company-footer></app-company-footer>
            <div
              class="footer_menu d-block d-md-none"
              *ngIf="
                !(companyAppConfig?.valueReport?.isEnabled || companyName === 'opscan') && (guestUser || isInvestor)
              "
            >
              <button mat-stroked-button color="primary" class="get-approved mr-3" (click)="preApprovedAction()">
                {{ appState.companyInfoValue?.ctaConfig?.getPreApproval?.agentCtaButtonLabel || 'Get Pre-Approved' }}
              </button>
              <button mat-flat-button color="primary" class="get-approved mr-4" (click)="schedulePropertyVisit()">
                {{ appState.companyInfoValue?.ctaConfig?.scheduleVisit?.agentCtaButtonLabel || 'Schedule Showing' }}
              </button>
            </div>
          </div>
        </div>
        <!-- Multiple Property Details -->

        <div class="propdetails_base container" *ngIf="showMultipleProperty && isPropertyDataExists == true">
          <div class="propdetails_wrap">
            <div class="scroller">
              <cdk-virtual-scroll-viewport class="mb-1 fullHeightVH" itemSize="100">
                <div *cdkVirtualFor="let property of multiplePropertyList; let i = index; trackBy: trackByFn">
                  <mat-card class="mb-1" (click)="showMultipleDetails(property)">
                    <div class="row">
                      <ng-container>
                        <div class="col-lg-6">
                          <div class="numberWrap">
                            <div class="number">{{ i + 1 }}</div>
                            <h6 class="mb-0 truncate">
                              {{ property.Address | IsValueExist }}
                            </h6>
                            <small class="badge text-white">{{ property.PropertySubType | IsValueExist }}</small>
                            <small class="badge text-white ml-1 bg-secondary">
                              <ng-container
                                *ngIf="(propertySheetFacade.getAppliedFilterStatus() | async) && property.isFiltered"
                              >
                                Filtered
                              </ng-container>
                              <ng-container
                                *ngIf="(propertySheetFacade.getAppliedFilterStatus() | async) && !property.isFiltered"
                              >
                                Not Filtered
                              </ng-container>
                            </small>
                            <small
                              *ngIf="property.propensityType && authorizeService.canView('propensityFilter')"
                              class="badge text-white ml-1"
                              [ngStyle]="{
                                'background-color':
                                  property.propensityType === 'cold'
                                    ? '#17a2b8'
                                    : property.propensityType === 'warm'
                                    ? '#ffc107'
                                    : '#ff0000'
                              }"
                            >
                              {{ property.propensityType | uppercase }}</small
                            >
                            <small
                              *ngIf="property && property.Lst_StandardStatus && property.Lst_StandardStatus === 'Sold'"
                              class="badge text-white ml-1"
                              [ngStyle]="{ 'background-color': '#3f51b5' }"
                            >
                              {{ property.Lst_StandardStatus | uppercase }}</small
                            >
                            <small
                              *ngIf="
                                property &&
                                property.Lst_StandardStatus &&
                                (property.Lst_StandardStatus === 'Active' ||
                                  property.Lst_StandardStatus === 'Active Under Contract')
                              "
                              class="badge text-white ml-1"
                              [ngStyle]="{ 'background-color': '#8bc34a' }"
                            >
                              {{ property.Lst_StandardStatus | uppercase }}</small
                            >
                            <small
                              *ngIf="
                                property && property.Lst_StandardStatus && property.Lst_StandardStatus === 'Pending'
                              "
                              class="badge text-white ml-1"
                              [ngStyle]="{ 'background-color': '#f69832' }"
                            >
                              {{ property.Lst_StandardStatus | uppercase }}</small
                            >
                            <small
                              *ngIf="
                                property &&
                                property.Lst_StandardStatus &&
                                (property.Lst_StandardStatus === 'NULL' ||
                                  property.Lst_StandardStatus === 'Cancel/Withdrawn' ||
                                  property.Lst_StandardStatus === 'Contingent' ||
                                  property.Lst_StandardStatus === 'Delisted' ||
                                  property.Lst_StandardStatus === 'Unknown' ||
                                  property.Lst_StandardStatus === 'Unlisted')
                              "
                              class="badge text-white ml-1"
                              [ngStyle]="{ 'background-color': '#833f2a' }"
                            >
                              {{ property.Lst_StandardStatus | uppercase }}</small
                            >
                            <small class="flipBadge ml-1" *ngIf="(property.Lst_FlipDuration | IsValueExist) != '--'"
                              >FLIP</small
                            >
                          </div>
                        </div>
                        <div class="col-lg-4 col-9 text-center mobTextl">
                          <ul class="prop_highlight pl-0 mb-0">
                            <li [matTooltip]="'Bed'">
                              <img src="../../assets/images/bed.svg" width="18" />
                              <p>{{ property.BedroomsTotal | IsValueExist }}</p>
                            </li>
                            <li [matTooltip]="'Bath'">
                              <img src="../../assets/images/bath.svg" width="18" />
                              <p>{{ property.BathroomsTotalInteger | IsValueExist }}</p>
                            </li>
                            <li [matTooltip]="'Living Area'">
                              <img src="../../assets/images/living_area.svg" width="18" />
                              <p>
                                {{ property.LivingArea | IsValueExist }}
                                <small *ngIf="property.LivingArea"> sq.ft</small>
                              </p>
                            </li>
                            <li [matTooltip]="'Lot Size Square Feet'">
                              <img src="../../assets/images/land_area.svg" width="18" />
                              <p [innerHTML]="property.LotSizeSquareFeet | SqftToAcresConverter"></p>
                            </li>
                          </ul>
                        </div>
                      </ng-container>
                      <div
                        class="col-lg-2 col-3 text-right"
                        *ngIf="!(companyAppConfig?.valueReport?.isEnabled || companyName === 'opscan')"
                      >
                        <button
                          mat-flat-button
                          class="fav"
                          (click)="followProperty(property); $event.stopPropagation()"
                        >
                          <mat-icon class="material-icons-new outline-favorite" *ngIf="!property.isFavorite">
                          </mat-icon>
                          <mat-icon *ngIf="property.isFavorite">favorite</mat-icon>
                        </button>
                      </div>
                    </div>
                  </mat-card>
                </div>
                <app-company-footer></app-company-footer>
              </cdk-virtual-scroll-viewport>
            </div>
          </div>
        </div>

        <div class="text-center no_property_img" style="margin: 140px" *ngIf="isPropertyDataExists == false">
          <img src="../../../../../assets/images/spend.jpg" width="150" alt="property" class="opacity-80" />
          <h6 class="mt-4 pl-1 pl-md-0">
            Requested property could not be found
            <small class="btn-block mt-2"> Requested property not found</small>
          </h6>
          <hr />
          <button mat-flat-button type="button" color="primary" class="material-icons pull-center" (click)="onClose()">
            Close
          </button>
        </div>
      </div>
    </div>
  </mat-sidenav>
</div>
